// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-20T17:35:55.475Z
// Property: The Fletcher  (ID: 6767906449167028)
// Collections: 17 amenities, 3 floorplans (live), 43 photos, 39 POIs, 14 reviews, 2 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162417",
  "multihub_property_id": "6767906449167028",
  "property_external_id": "100121162",
  "property_zillow_url": "https://www.zillow.com/apartments/la-mesa-ca/the-fletcher/5XjTGy/",
  "property_apartments_url": "https://www.apartments.com/the-fletcher-la-mesa-ca/1kpg0v6/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Fletcher/data=!4m2!3m1!1s0x0:0xf25c8824d3dac3c0?sa=X&ved=2ahUKEwjvl_Xh3P6SAxUrJEQIHc9EPD8Q_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "42169739665",
  "property_crm_software": "Entrata LeadManager",
  "property_pm_software": "Entrata",
  "property_pm_info": "Entrata",
  "property_status": null,
  "property_slug": "the-fletcher",
  "property_name": "The Fletcher ",
  "property_website_url": "https://www.thefletcherapts.com/",
  "property_domain": "https://www.thefletcherapts.com/",
  "property_address": "5360 Marengo Ave",
  "property_full_address": "5360 Marengo Ave, La Mesa, CA 91942",
  "property_address_1": "5360 Marengo Ave",
  "property_address_2": null,
  "property_address_city": "La Mesa",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "91942",
  "property_address_country": "US",
  "property_address_county": "San Diego County",
  "property_neighborhood_address": "La Mesa",
  "property_address_latitude": "32.7765622",
  "property_address_longitude": "-117.0239206",
  "property_email": "thefletcher@sunrisemgmt.com",
  "property_phone": "(619) 465-3714",
  "property_call_tracking_phone": "619-812-1837",
  "property_company_name": "Sunrise Management",
  "property_company_url": "https://www.sunrisemgmt.com/",
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "Your Perfect Place to Call Home, The Fletcher.",
  "property_long_description": "<p>Nestled in the vibrant heart of La Mesa, The Fletcher offers a unique living experience just minutes away from La Mesa&amp;rsquo;s bustling Downtown Village and San Diego&amp;rsquo;s picturesque Bay Front and beaches. Our apartment community combines tranquil living with the convenience of urban amenities, providing you with the perfect sanctuary to call home.</p><p><br></p><p>Our spacious one, and two-bedroom apartments are designed to elevate your lifestyle. Newly renovated apartments feature wood-style plank flooring, stainless steel appliances, tile backsplashes, central AC/Heat and designer finishes that add a touch of sophistication and comfort to your living space. Take a dip in our pool or make use of our convenient on-site laundry facilities.</p><p><br></p><p>At The Fletcher, we are dedicated to offering not just a place to live, but a place to thrive. Come experience the perfect blend of style, convenience, and charm. Welcome home!</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019fb452-6332-735e-9a2b-756de04da14f.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool at sunset with lounge chairs and apartment buildings in the background.",
    "public_id": "019fb452-6332-735e-9a2b-756de04da14f",
    "storage_key": "property/6767906449167028/019fb452-6332-735e-9a2b-756de04da14f.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167028/01a15a5e-9cd8-73c1-a85a-39ba0006f55f.mp4",
  "property_featured_video_media": {
    "public_id": "01a15a5e-9cd8-73c1-a85a-39ba0006f55f",
    "storage_key": "property/6767906449167028/01a15a5e-9cd8-73c1-a85a-39ba0006f55f.mp4",
    "thumbnail_key": "property/6767906449167028/01a15a5e-9cd8-73c1-a85a-39ba0006f55f_thumb.webp",
    "size_bytes": 69539173,
    "classification": "Community",
    "title": "Explore Our Beautiful Apartment Community",
    "description": "Discover the amenities and living spaces at our vibrant apartment community. Enjoy the pool, lounge areas, and modern interiors."
  },
  "property_total_units": "28",
  "property_year_built": "1970",
  "property_year_renovated": null,
  "property_walk_score": "71",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "85.71428571428571",
  "property_admin_fee": null,
  "property_application_fee": "45",
  "property_fees_deposit_info": "Security deposit: $250.00 (refundable).",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "500",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "30",
  "property_pet_restrictions": "We welcome cats and dogs up to 30 lbs. Maximum of 2 pets per apartment.",
  "property_pet_policy_description": "Pet deposit: $500.00 (refundable). Monthly pet rent: $50.00/month.",
  "property_petpolicy_info": "Pet Policy Type: Cat, Dog\nMax Number of Pets: 2\nPet deposit fee min: $500\nPet monthly rent min: $50\nPet policy fee min/max: $50 - $100",
  "property_online_leasing_url": "https://thefletcher.prospectportal.com/La Mesa/The Fletcher",
  "property_resident_portal_url": "https://thefletcher.residentportal.com/auth",
  "property_apply_now_url": "https://thefletcher.prospectportal.com/Apartments/module/application_authentication/popup/false/kill_session/1/property/100121162/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bc-0f2a-70be-8b55-eef36660a008.webp",
  "property_primary_logo_media": {
    "alt_text": "The Fletcher logo",
    "public_id": "019d08bc-0f2a-70be-8b55-eef36660a008",
    "storage_key": "property/6767906449167028/019d08bc-0f2a-70be-8b55-eef36660a008.webp",
    "width": 569,
    "height": 88
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019e8e55-b19e-75fb-9648-270dd280ae13.webp",
  "property_icon_media": {
    "alt_text": "Property logo",
    "public_id": "019e8e55-b19e-75fb-9648-270dd280ae13",
    "storage_key": "property/6767906449167028/019e8e55-b19e-75fb-9648-270dd280ae13.webp",
    "width": 32,
    "height": 32
  },
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019e98bf-9fc6-76ed-95db-da1203060fd8.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Fletcher logo",
    "public_id": "019e98bf-9fc6-76ed-95db-da1203060fd8",
    "storage_key": "property/6767906449167028/019e98bf-9fc6-76ed-95db-da1203060fd8.webp",
    "width": 569,
    "height": 88
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019e98bf-9214-777b-97dd-d4dd299237e5.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Fletcher property logo",
    "public_id": "019e98bf-9214-777b-97dd-d4dd299237e5",
    "storage_key": "property/6767906449167028/019e98bf-9214-777b-97dd-d4dd299237e5.webp",
    "width": 569,
    "height": 88
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162417/01a15551-ae4d-75a8-a6aa-7bc8aa917e90.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162417/019d06cf-4134-73f9-aa2c-2cbcff86a11a.webp",
  "property_company_logo_media": {
    "alt_text": "Sunrise Management logo",
    "public_id": "019d06cf-4134-73f9-aa2c-2cbcff86a11a",
    "storage_key": "company/5767906449162417/019d06cf-4134-73f9-aa2c-2cbcff86a11a.webp",
    "width": 256,
    "height": 256
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162417/01a15551-016c-71e4-a66c-b5d1e83b79cb.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162417/01a15551-0100-7115-9635-6815428ea63d.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#111111",
  "property_secondary_color": "#f8f8f8",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "780 - 900",
  "property_sqft_min": "780",
  "property_sqft_max": "900",
  "property_price_range": "$2298 - $2929",
  "property_price_min": "2298",
  "property_price_max": "2929",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/people/The-Fletcher/61583912867608/",
  "property_instagram_url": "https://www.instagram.com/thefletcherapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJHVbqzIpX2YARwMPa0ySIXPI",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Fletcher ",
  "property_home_romance_title": "Embrace the Comfort of Your New Community Home",
  "property_home_amenities_blurb": "Welcome to The Fletcher in La Mesa, CA, where modern living meets comfort. Choose from stylish one and two-bedroom apartments featuring newly renovated interiors, stainless steel appliances, and private backyards. Enjoy community amenities like a refreshing pool, BBQ area, and easy freeway access. Your new home awaits!",
  "property_home_floorplans_blurb": "At The Fletcher in La Mesa, CA, your ideal living space awaits. Choose from our stylish one and two-bedroom floor plans designed for comfort and convenience. Dive into our selection today—your perfect apartment home is just a click away!",
  "property_home_gallery_blurb": "At The Fletcher in La Mesa, CA, luxury meets comfort in our stunning one and two-bedroom apartments. Enjoy modern amenities like stainless steel appliances, custom tile backsplashes, and serene private backyards in select units. Dive into leisure with a community pool and BBQ area. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At The Fletcher in vibrant La Mesa, CA, your lifestyle meets convenience. Choose from thoughtfully designed one and two-bedroom floor plans and immerse yourself in a community rich with opportunities. Revel in nearby outdoor adventures at Cowles Mountain, explore parks like Mission Trails, and enjoy cultural experiences at San Diego State University. Embrace a neighborhood that truly has it all!",
  "property_home_reviews_blurb": "Welcome to The Fletcher in La Mesa, CA, where a perfect 5.0 rating speaks volumes. As one resident puts it, “This property is great and I love the management team!” Join a community that prioritizes your happiness—see what our residents have to say about living at The Fletcher!",
  "property_neighborhood_blurb": "At The Fletcher in La Mesa, vibrant living meets endless adventure. Enjoy the scenic beauty of nearby Cowles Mountain, explore Mission Trails Regional Park, or unwind at Cuyamaca College and the San Diego Air & Space Museum. Experience the perfect blend of community and convenience—come see what surrounds your new home!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Fletcher in La Mesa, CA, luxury meets comfort. Choose from one or two-bedroom floor plans featuring newly renovated interiors with stainless steel appliances and custom tile backsplashes. Enjoy our community pool, BBQ area, and pet-friendly policies, all while reveling in convenient freeway access. Experience a vibrant lifestyle today!",
  "property_applynow_blurb": "At The Fletcher in La Mesa, CA, choose from stunning one and two-bedroom apartments featuring newly renovated interiors, stainless steel appliances, and private backyards in select units. Enjoy a refreshing dip in the community pool, fire up the BBQ area, and embrace pet-friendly living. Start your journey and lease online today!",
  "property_contactus_blurb": "At The Fletcher in La Mesa, CA, we offer thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. Embrace comfort and convenience in an inviting community. Have questions? Our leasing team is ready to assist you—reach out and let’s find your perfect home today!",
  "property_faqs_blurb": "At The Fletcher in La Mesa, CA, we offer thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle needs. Have questions? Our FAQs page is the perfect resource to help you uncover everything you need to know about living in our vibrant community.",
  "property_floorplans_blurb": "At The Fletcher in La Mesa, CA, each thoughtfully designed floor plan fits your lifestyle, whether you crave the intimacy of a one-bedroom or need the spaciousness of a two-bedroom. Browse our available apartment homes to uncover the perfect layout that harmonizes comfort and style in your new home.",
  "property_gallery_blurb": "At The Fletcher in La Mesa, CA, vibrant living awaits you! With spacious one and two-bedroom floor plans featuring stunning renovations and modern amenities, including a community pool, BBQ area, and private backyards, you'll find your perfect retreat. Picture yourself enjoying life here—a place to call home!",
  "property_interactivemap_blurb": "At The Fletcher in La Mesa, CA, modern living meets comfort with our stylish one- and two-bedroom apartments. Indulge in amenities such as a sparkling community pool, BBQ area, and dog-friendly spaces, all while enjoying renovated interiors and easy freeway access. Let your convenient lifestyle start today—explore our interactive community map!",
  "property_pets_blurb": "At The Fletcher in La Mesa, CA, your furry friends are part of the family! Our community embraces cats and dogs weighing up to 30 lbs, with a warm and inviting space for you and your pets to thrive. Enjoy life together, with a pet-friendly atmosphere and convenient amenities.",
  "property_referafriend_blurb": "At The Fletcher in La Mesa, CA, great friends make great neighbors! With spacious one and two-bedroom floor plans, our vibrant community offers an inviting atmosphere perfect for sharing life’s moments. Don't keep us a secret—refer a friend today and enjoy the perks of living together!",
  "property_residentaccess_blurb": "Welcome to The Fletcher in La Mesa, CA, where comfort meets convenience! Choose from our thoughtfully designed one and two-bedroom floor plans tailored to fit your lifestyle. Log in to your resident portal for smooth rent payments, maintenance scheduling, and easy access to community updates. Your perfect living experience awaits!",
  "property_reviews_blurb": "At The Fletcher in La Mesa, CA, our residents can't stop raving about their experience! With a perfect 5.0 rating, one resident declares, \"This property is great and I love the management team!\" Join a thriving community that values exceptional living—read our reviews and feel the warmth of home.",
  "property_created_at": "1770052751642",
  "property_scheduletour_blurb": "At The Fletcher in La Mesa, CA, our thoughtfully designed one and two-bedroom apartments offer the perfect blend of comfort and style. Ready to envision your new home? Schedule a tour today and see what our residents cherish most about living in our welcoming community! Testimonials await!",
  "property_thankyou_blurb": "Thank you for your interest in The Fletcher, La Mesa's premier apartment community! Whether you prefer a cozy one-bedroom or a spacious two-bedroom layout, we have the perfect floor plan to suit your lifestyle. Our team will be in touch soon—exciting living awaits!",
  "property_virtualtours_blurb": "At The Fletcher in La Mesa, CA, our thoughtfully designed one and two-bedroom floor plans cater to your unique lifestyle. Immerse yourself in our vibrant community by taking a virtual tour, where stylish spaces meet modern living. Your ideal home awaits—see it all from the comfort of your couch!",
  "property_copyright": "2026 All Rights Reserved. The Fletcher ",
  "property_seo_title_home": "The Fletcher  |  Apartments in La Mesa, CA",
  "property_seo_description_home": "Experience modern living at The Fletcher in La Mesa. Enjoy renovated interiors, a community pool, and spacious floor plans—your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | La Mesa, CA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at The Fletcher in La Mesa, CA. From cozy one-bedrooms to spacious two-bedrooms, browse our diverse floor plans today!",
  "property_seo_title_amenities": "Amenities | La Mesa, CA Apartments for Rent",
  "property_seo_description_amenities": "Unwind at The Fletcher in La Mesa, CA! Enjoy modern living with resort-style amenities like a pool, BBQ area, and stylish interiors. Your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in La Mesa, CA",
  "property_seo_description_gallery": "Experience vibrant living at The Fletcher in La Mesa, CA! From stunning backyards to stylish interiors, find your perfect 1 or 2-bedroom oasis today!",
  "property_seo_title_virtualtours": "Virtual Tours | The Fletcher  Apartments",
  "property_seo_description_virtualtours": "Step into comfort at The Fletcher in La Mesa, CA! Take a virtual tour of our stylish one and two-bedroom apartments. Your perfect home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | The Fletcher  Apartments",
  "property_seo_description_interactivemap": "Discover your haven at The Fletcher, La Mesa, CA! Modern interiors, a community pool, and pet-friendly amenities. Your new home awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in La Mesa, CA",
  "property_seo_description_neighborhood": "Uncover local gems around The Fletcher in La Mesa, CA! Enjoy vibrant neighborhoods, delicious eateries, and convenient amenities just steps from your new home.",
  "property_seo_title_contact": "Contact Us | The Fletcher ",
  "property_seo_description_contact": "Connect with The Fletcher in La Mesa, CA! Whether you're interested in a cozy one-bedroom or spacious two-bedroom, our leasing team is here to help.",
  "property_seo_title_faqs": "FAQs | Apartments in La Mesa, CA",
  "property_seo_description_faqs": "Find answers to your questions about The Fletcher in La Mesa, CA! Enjoy amenities like a community pool, dog-friendly spaces, and modern, renovated apartments.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in La Mesa, CA",
  "property_seo_description_reviews": "Experience life at The Fletcher in La Mesa, CA! See resident reviews and learn why our newly renovated apartments and amenities make it home sweet home.",
  "property_seo_title_applynow": "Apply Now | Apartments in La Mesa, CA",
  "property_seo_description_applynow": "Experience modern living at The Fletcher in La Mesa! Enjoy renovated interiors, a community pool, and pet-friendly spaces. Apply online for your dream home!",
  "property_seo_title_residentaccess": "Resident Access | The Fletcher ",
  "property_seo_description_residentaccess": "Effortlessly manage your home at The Fletcher, La Mesa, CA. Use the resident portal for rent payments, maintenance requests, and updates!",
  "property_seo_title_referafriend": "Refer A Friend | The Fletcher ",
  "property_seo_description_referafriend": "Refer a friend to The Fletcher in La Mesa, CA, and let great friendships blossom into great neighbors. Share the joy of community living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Fletcher ",
  "property_seo_description_scheduletour": "Experience upscale living at The Fletcher in La Mesa, CA. Schedule a tour today and envision your future in our vibrant, welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | The Fletcher ",
  "property_seo_description_privacy": "Safeguarding your peace of mind is our priority at The Fletcher in La Mesa. Dive into our privacy policy to see how we protect your information.",
  "property_seo_title_accessibility": "Website Accessibility | The Fletcher ",
  "property_seo_description_accessibility": "Discover true accessibility at The Fletcher in La Mesa, CA. We prioritize digital inclusion for all. Join our welcoming community today!",
  "property_seo_title_sitemap": "Sitemap | The Fletcher ",
  "property_seo_description_sitemap": "Navigate your way to your dream home at The Fletcher in La Mesa, CA. Check out our sitemap for a seamless journey to your perfect apartment!",
  "property_seo_title_thankyou": "Thank You | The Fletcher ",
  "property_seo_description_thankyou": "Thank you for reaching out to The Fletcher in La Mesa, CA! Our team will connect soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in La Mesa, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1792517717753",
  "amenities": [
    {
      "id": "custom_1dfe5a81-71cd-4980-8345-7bd4cb27dab2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "external_id": "false",
      "title": "Community Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bf254392-de61-40c3-a7ae-1472c7356c99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "external_id": "false",
      "title": "BBQ Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7d6415b7-bdaa-4893-b13a-04c5e6a964d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Laundry Facilities",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_415a1184-3a72-49ae-999f-b04358879e23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ff299b07-bc18-4152-b1e8-da8bb00d6c7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "external_id": "false",
      "title": "Dog/Cat Friendly",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_af5ff1ae-d513-443b-ab18-d665559e362e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Access to 8 and 125 Freeways",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5bf98af6-34cc-4521-b46d-b421e81f19b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "external_id": "false",
      "title": "Newly Renovated Interiors",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cb75dd32-d1b8-4561-b4bc-1fc5746da848",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "external_id": "false",
      "title": "Central AC/Heat",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_31ee3e25-15f0-433e-9174-5803e446e1ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "external_id": "false",
      "title": "Custom Tile Backsplash",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0d268919-a5ba-4503-a7be-b87e45e49fa8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "external_id": "false",
      "title": "Hard Surface Floors",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8e795ce0-a7a5-4154-b66d-97b0d44bfb14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fe6547b5-1531-4d0c-9fde-1425585f19f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher and Garbage Disposal",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b735cfe4-998e-4379-8c51-a28b6559ca2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "external_id": "false",
      "title": "Quiet, Dual‑Pane Vinyl Windows",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c37d43e9-c7aa-45c1-bda6-1f7c77055ae9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "external_id": "false",
      "title": "Keyless Entry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_36f51fb5-2e91-4f07-8a12-24b09fa864d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6db1263d-6b12-447c-9338-19a6ab4185c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "external_id": "false",
      "title": "Cable/Internet Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4538793d-4bf7-4994-b13b-ab21b5a00f97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "external_id": "false",
      "title": "Private Backyards*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_12617de7ea3b300c7fda0bf1",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f6445-b427-7008-ba34-0ba470c172cf.webp",
      "image_media": {
        "alt_text": "Modern kitchen sink with a pull-down faucet overlooking a spacious living area with sliding glass doors.",
        "public_id": "019f6445-b427-7008-ba34-0ba470c172cf",
        "storage_key": "property/6767906449167028/019f6445-b427-7008-ba34-0ba470c172cf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Explore the contemporary kitchen and living space, perfect for relaxation and entertaining. Features a sleek sink, modern faucet, and abundant natural light.",
      "link": "false",
      "alt_text": "Modern kitchen sink with a pull-down faucet overlooking a spacious living area with sliding glass doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/07/14/085446/6a564db551a3b8.59832805445.jpg"
    },
    {
      "id": "ec_e1d153f2dee8bd1b99fa52ba",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-6c79-70e1-99d2-647a81fd7ec4.webp",
      "image_media": {
        "alt_text": "Apartment community swimming pool at sunset with lounge chairs and palm trees.",
        "public_id": "019f8a8b-6c79-70e1-99d2-647a81fd7ec4",
        "storage_key": "property/6767906449167028/019f8a8b-6c79-70e1-99d2-647a81fd7ec4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, surrounded by comfortable lounge chairs and lush palm trees, under a breathtaking sunset sky.",
      "link": "false",
      "alt_text": "Apartment community swimming pool at sunset with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/034328/6a2c7d7e7b9678.57448729914.jpg"
    },
    {
      "id": "ec_ab5e226e995c9d0fec7537ff",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f6445-b494-7652-9f46-37cc18acec9e.webp",
      "image_media": {
        "alt_text": "Empty living room with wood-look flooring and sliding glass doors to a patio.",
        "public_id": "019f6445-b494-7652-9f46-37cc18acec9e",
        "storage_key": "property/6767906449167028/019f6445-b494-7652-9f46-37cc18acec9e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and bright living area with neutral finishes and access to a private outdoor space.",
      "link": "false",
      "alt_text": "Empty living room with wood-look flooring and sliding glass doors to a patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/07/14/085444/6a564db3707454.99161136531.jpg"
    },
    {
      "id": "ec_ca347dd29fa3b6607ad35e18",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-74d2-71a7-910b-546b3371d2fb.webp",
      "image_media": {
        "alt_text": "The Fletcher apartment building exterior with a modern sign and tropical landscaping.",
        "public_id": "019f8a8b-74d2-71a7-910b-546b3371d2fb",
        "storage_key": "property/6767906449167028/019f8a8b-74d2-71a7-910b-546b3371d2fb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to The Fletcher, where modern living meets lush tropical landscaping. Discover our vibrant community.",
      "link": "false",
      "alt_text": "The Fletcher apartment building exterior with a modern sign and tropical landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/034009/6a2c7cb7a2c6c1.24531476432.jpg"
    },
    {
      "id": "ec_ed4f607598f1f0845a352366",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f6445-b610-703d-b4f9-08d337e7ec4a.webp",
      "image_media": {
        "alt_text": "Spacious living room with open-concept kitchen and wood-look flooring.",
        "public_id": "019f6445-b610-703d-b4f9-08d337e7ec4a",
        "storage_key": "property/6767906449167028/019f6445-b610-703d-b4f9-08d337e7ec4a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the open-concept living space featuring modern wood-look flooring and a seamlessly integrated kitchen. Perfect for modern living and entertaining.",
      "link": "false",
      "alt_text": "Spacious living room with open-concept kitchen and wood-look flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/07/14/085448/6a564db7278792.99845584276.jpg"
    },
    {
      "id": "ec_cbf4943e44ce89e1e28deaf5",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019ebf8c-c189-708f-b4bc-61f4e5bfacc0.webp",
      "image_media": {
        "alt_text": "Exterior of The Fletcher apartment building at dusk with palm trees and illuminated pathways.",
        "public_id": "019ebf8c-c189-708f-b4bc-61f4e5bfacc0",
        "storage_key": "property/6767906449167028/019ebf8c-c189-708f-b4bc-61f4e5bfacc0.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover The Fletcher, a vibrant apartment community offering modern living in a beautifully landscaped setting. Experience comfort and convenience.",
      "link": "false",
      "alt_text": "Exterior of The Fletcher apartment building at dusk with palm trees and illuminated pathways.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033805/6a2c7c3c0e94c6.43192174268.jpg"
    },
    {
      "id": "ec_e143676b04322d8340232764",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-6aeb-7078-bbd0-c260fac651f0.webp",
      "image_media": {
        "alt_text": "Spacious living room with hardwood floors, white walls, and a ceiling fan.",
        "public_id": "019f8a8b-6aeb-7078-bbd0-c260fac651f0",
        "storage_key": "property/6767906449167028/019f8a8b-6aeb-7078-bbd0-c260fac651f0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the open-concept living space in this apartment, featuring beautiful hardwood floors and a modern ceiling fan. The large sliding glass door leads to a private patio or balcony, perfect for relaxing.",
      "link": "false",
      "alt_text": "Spacious living room with hardwood floors, white walls, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/07/14/085450/6a564db901aac5.79908414126.jpg"
    },
    {
      "id": "ec_51546403da56f5e770b96dea",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-6ccc-73b5-a1eb-b9dc75b27530.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
        "public_id": "019f8a8b-6ccc-73b5-a1eb-b9dc75b27530",
        "storage_key": "property/6767906449167028/019f8a8b-6ccc-73b5-a1eb-b9dc75b27530.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Chic and functional kitchen featuring stainless steel appliances, ample cabinet space, and elegant backsplash.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033957/6a2c7cabe87920.69177683970.jpg"
    },
    {
      "id": "ec_cd4d4d43d621be698f94cd42",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-6a87-7388-a47b-8f25a8531d67.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, black faucet, and view into a bathtub.",
        "public_id": "019f8a8b-6a87-7388-a47b-8f25a8531d67",
        "storage_key": "property/6767906449167028/019f8a8b-6a87-7388-a47b-8f25a8531d67.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this modern bathroom, featuring a sleek white vanity, black fixtures, and a serene bathing area.",
      "link": "false",
      "alt_text": "Modern bathroom with white vanity, black faucet, and view into a bathtub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/07/14/085452/6a564dbad31fb1.00823726958.jpg"
    },
    {
      "id": "ec_4d4eadd2089140235ede934a",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-88bc-775a-9e2b-3b53a8c2bf0d.webp",
      "image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and wood-look flooring.",
        "public_id": "019f8a8b-88bc-775a-9e2b-3b53a8c2bf0d",
        "storage_key": "property/6767906449167028/019f8a8b-88bc-775a-9e2b-3b53a8c2bf0d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into this beautifully renovated kitchen, featuring crisp white cabinetry, sleek countertops, and modern stainless steel appliances. Perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern white kitchen with stainless steel appliances and wood-look flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033801/6a2c7c3781be53.34486751504.jpg"
    },
    {
      "id": "ec_3a8e4c32fb5f7c7be68ee392",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-8a31-70bd-8582-b997df15487c.webp",
      "image_media": {
        "alt_text": "Empty bedroom with mirrored closet doors and light wood flooring.",
        "public_id": "019f8a8b-8a31-70bd-8582-b997df15487c",
        "storage_key": "property/6767906449167028/019f8a8b-8a31-70bd-8582-b997df15487c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring light wood floors, white walls, and a large mirrored closet, offering a clean and open feel.",
      "link": "false",
      "alt_text": "Empty bedroom with mirrored closet doors and light wood flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/07/14/085454/6a564dbca57072.56229104639.jpg"
    },
    {
      "id": "ec_a1fb4ead295a7ed1dfafe521",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-8c9d-7721-8a1e-1cd14026585b.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel appliances, and a tiled backsplash.",
        "public_id": "019f8a8b-8c9d-7721-8a1e-1cd14026585b",
        "storage_key": "property/6767906449167028/019f8a8b-8c9d-7721-8a1e-1cd14026585b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring white cabinetry, a sleek tiled backsplash, stainless steel appliances including a refrigerator and range, and durable countertops.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, stainless steel appliances, and a tiled backsplash.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033803/6a2c7c39b3f6e4.94766388119.jpg"
    },
    {
      "id": "ec_215b72ad265e4aa658f4a9f6",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f6445-e16e-766e-b046-fc83f0829ba5.webp",
      "image_media": {
        "alt_text": "Empty bedroom with wood-look flooring and mirrored closet doors.",
        "public_id": "019f6445-e16e-766e-b046-fc83f0829ba5",
        "storage_key": "property/6767906449167028/019f6445-e16e-766e-b046-fc83f0829ba5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom with elegant wood-look flooring and mirrored closet doors, ready for your personal touch.",
      "link": "false",
      "alt_text": "Empty bedroom with wood-look flooring and mirrored closet doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/07/14/085455/6a564dbe706ed6.03348696940.jpg"
    },
    {
      "id": "ec_f1174dd6f4441eaf84ff06e9",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-98be-74b8-8ba7-4d79ca77ae2e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a gray tile backsplash.",
        "public_id": "019f8a8b-98be-74b8-8ba7-4d79ca77ae2e",
        "storage_key": "property/6767906449167028/019f8a8b-98be-74b8-8ba7-4d79ca77ae2e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring a stainless steel refrigerator, dishwasher, range, microwave hood, and a deep sink with a pull-down faucet. White cabinetry and a stylish gray tile backsplash complete the look.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a gray tile backsplash.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033959/6a2c7cae2ac0b5.59638827454.jpg"
    },
    {
      "id": "ec_115e9d789921c957b6b8a1e7",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019ebf8d-1074-774b-b347-22ad45e2c3ba.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, quartz countertops, and stainless steel appliances.",
        "public_id": "019ebf8d-1074-774b-b347-22ad45e2c3ba",
        "storage_key": "property/6767906449167028/019ebf8d-1074-774b-b347-22ad45e2c3ba.webp",
        "width": 3072,
        "height": 2043
      },
      "title": "Apartment",
      "description": "Discover a beautifully appointed kitchen featuring sleek white cabinetry, durable quartz countertops, a stylish backsplash, and modern stainless steel appliances.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, quartz countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033758/6a2c7c35356166.70949596653.jpg"
    },
    {
      "id": "ec_b348b814db30e92e82d8be9a",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-aa8a-741c-9f3a-ec26ae09b088.webp",
      "image_media": {
        "alt_text": "Empty apartment living room with wood floors and ceiling fan.",
        "public_id": "019f8a8b-aa8a-741c-9f3a-ec26ae09b088",
        "storage_key": "property/6767906449167028/019f8a8b-aa8a-741c-9f3a-ec26ae09b088.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Apartment",
      "description": "Spacious living area with a ceiling fan and large windows, ready for your personal touch.",
      "link": "false",
      "alt_text": "Empty apartment living room with wood floors and ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033756/6a2c7c3308a3f5.65410282327.jpg"
    },
    {
      "id": "ec_458308a06a2fc49042d8e1d2",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-ab50-77e7-a889-0ac28cb547a3.webp",
      "image_media": {
        "alt_text": "Interior view of an empty apartment living room with wood-look flooring, white walls, and a large window with blinds.",
        "public_id": "019f8a8b-ab50-77e7-a889-0ac28cb547a3",
        "storage_key": "property/6767906449167028/019f8a8b-ab50-77e7-a889-0ac28cb547a3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and bright living area in an apartment, featuring modern wood-look flooring and ample natural light from the large window. Perfect for creating your ideal living space.",
      "link": "false",
      "alt_text": "Interior view of an empty apartment living room with wood-look flooring, white walls, and a large window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033948/6a2c7ca32d89d0.65759252807.jpg"
    },
    {
      "id": "ec_a578700c036c4bb541f6f037",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-b477-755b-ac80-abeea2652243.webp",
      "image_media": {
        "alt_text": "Empty bedroom with wood-look flooring and a large window.",
        "public_id": "019f8a8b-b477-755b-ac80-abeea2652243",
        "storage_key": "property/6767906449167028/019f8a8b-b477-755b-ac80-abeea2652243.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring new wood-look flooring and a large window with blinds, offering ample natural light.",
      "link": "false",
      "alt_text": "Empty bedroom with wood-look flooring and a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033950/6a2c7ca559a1e6.16392666367.jpg"
    },
    {
      "id": "ec_faf9b9bc02a5efb0ab70d372",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-c9af-7341-b4ad-ad6b7254953a.webp",
      "image_media": {
        "alt_text": "Empty living room and kitchen area with light wood floors and white walls.",
        "public_id": "019f8a8b-c9af-7341-b4ad-ad6b7254953a",
        "storage_key": "property/6767906449167028/019f8a8b-c9af-7341-b4ad-ad6b7254953a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area featuring light wood plank flooring and white walls, creating a bright and open atmosphere.",
      "link": "false",
      "alt_text": "Empty living room and kitchen area with light wood floors and white walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033955/6a2c7ca9b49bc9.26845624137.jpg"
    },
    {
      "id": "ec_1f59d33c876c9a62d2c88141",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-cc99-704e-af80-b56e5802fd90.webp",
      "image_media": {
        "alt_text": "Modern white bathroom with vanity, sink, mirror, and bathtub visible through an open door.",
        "public_id": "019f8a8b-cc99-704e-af80-b56e5802fd90",
        "storage_key": "property/6767906449167028/019f8a8b-cc99-704e-af80-b56e5802fd90.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this clean and updated bathroom featuring a spacious vanity, contemporary fixtures, and a bathtub for relaxation.",
      "link": "false",
      "alt_text": "Modern white bathroom with vanity, sink, mirror, and bathtub visible through an open door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033953/6a2c7ca77dbbd2.06647281153.jpg"
    },
    {
      "id": "ec_9bcc60e9528332a5898ebb87",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019ebf8d-71c5-76d9-9f2e-0d22d789c616.webp",
      "image_media": {
        "alt_text": "Balcony view of apartment building exterior with palm trees and stairs.",
        "public_id": "019ebf8d-71c5-76d9-9f2e-0d22d789c616",
        "storage_key": "property/6767906449167028/019ebf8d-71c5-76d9-9f2e-0d22d789c616.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the fresh air from your private balcony, overlooking the lush courtyard and exterior of the apartment buildings. Access units via convenient outdoor stairs.",
      "link": "false",
      "alt_text": "Balcony view of apartment building exterior with palm trees and stairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/034002/6a2c7cb04dc8e4.32430486155.jpg"
    },
    {
      "id": "ec_005ca0906998878fa872765b",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-cd52-7088-99f3-447ff7f09a1f.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
        "public_id": "019f8a8b-cd52-7088-99f3-447ff7f09a1f",
        "storage_key": "property/6767906449167028/019f8a8b-cd52-7088-99f3-447ff7f09a1f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, surrounded by comfortable lounge seating and lush greenery. Perfect for relaxation and soaking up the sun.",
      "link": "false",
      "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/034330/6a2c7d80a38951.49234297491.jpg"
    },
    {
      "id": "ec_58384b42b6420f3b8635c8a1",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-d1b8-71f0-b555-e2809a9d286b.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f8a8b-d1b8-71f0-b555-e2809a9d286b",
        "storage_key": "property/6767906449167028/019f8a8b-d1b8-71f0-b555-e2809a9d286b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded umbrellas. Perfect for relaxing and unwinding.",
      "link": "false",
      "alt_text": "Swimming pool with lounge chairs and umbrellas at an apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/034332/6a2c7d83122779.30519503305.jpg"
    },
    {
      "id": "ec_c06892ea6cca6c9be7783c7c",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-ea65-74e2-9104-695a927f66e3.webp",
      "image_media": {
        "alt_text": "Resort-style pool with lounge chairs and umbrellas.",
        "public_id": "019f8a8b-ea65-74e2-9104-695a927f66e3",
        "storage_key": "property/6767906449167028/019f8a8b-ea65-74e2-9104-695a927f66e3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and shaded umbrellas. The perfect oasis for relaxation and fun.",
      "link": "false",
      "alt_text": "Resort-style pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/034335/6a2c7d85747d70.69405101183.jpg"
    },
    {
      "id": "ec_938b3907b2d608ce87ef35e4",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019ebf8d-b86e-7559-8a50-49df09693369.webp",
      "image_media": {
        "alt_text": "Outdoor dining area with barbecue and pool",
        "public_id": "019ebf8d-b86e-7559-8a50-49df09693369",
        "storage_key": "property/6767906449167028/019ebf8d-b86e-7559-8a50-49df09693369.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy al fresco dining with built-in BBQ and comfortable seating, adjacent to the sparkling swimming pool.",
      "link": "false",
      "alt_text": "Outdoor dining area with barbecue and pool",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/034337/6a2c7d87f403b9.45547276662.jpg"
    },
    {
      "id": "ec_86d6994d496b22228be32b16",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-ea66-714d-9583-d519d0a5ed2f.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with wooden pergola and lush landscaping.",
        "public_id": "019f8a8b-ea66-714d-9583-d519d0a5ed2f",
        "storage_key": "property/6767906449167028/019f8a8b-ea66-714d-9583-d519d0a5ed2f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors in this beautifully landscaped patio area featuring a modern wooden pergola, perfect for relaxation and gatherings.",
      "link": "false",
      "alt_text": "Outdoor patio area with wooden pergola and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/034004/6a2c7cb2bc3314.62662603119.jpg"
    },
    {
      "id": "ec_52b147c8686ebcf477c62505",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019ebf8d-e1c8-77d1-9350-88f1852a611f.webp",
      "image_media": {
        "alt_text": "Walkway between apartment buildings lined with palm trees and lush greenery.",
        "public_id": "019ebf8d-e1c8-77d1-9350-88f1852a611f",
        "storage_key": "property/6767906449167028/019ebf8d-e1c8-77d1-9350-88f1852a611f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a stroll along the beautifully landscaped walkways, surrounded by mature palm trees and vibrant foliage. This community offers a serene and inviting atmosphere.",
      "link": "false",
      "alt_text": "Walkway between apartment buildings lined with palm trees and lush greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/034007/6a2c7cb53bc437.27289215820.jpg"
    },
    {
      "id": "ec_ad3bcff873a309957108b303",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-ee4f-7328-b402-69539bb54af9.webp",
      "image_media": {
        "alt_text": "Outdoor grill area with built-in stainless steel grill and granite countertop.",
        "public_id": "019f8a8b-ee4f-7328-b402-69539bb54af9",
        "storage_key": "property/6767906449167028/019f8a8b-ee4f-7328-b402-69539bb54af9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining with our spacious grill area, featuring a modern stainless steel grill and granite countertop, perfect for residents to gather and socialize.",
      "link": "false",
      "alt_text": "Outdoor grill area with built-in stainless steel grill and granite countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/034321/6a2c7d7820bf07.21314070823.jpg"
    },
    {
      "id": "ec_4dca7c8257390af00b087c42",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8b-ee53-777c-8305-c10ec2e3ee2a.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washers and dryers.",
        "public_id": "019f8a8b-ee53-777c-8305-c10ec2e3ee2a",
        "storage_key": "property/6767906449167028/019f8a8b-ee53-777c-8305-c10ec2e3ee2a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities available for residents.",
      "link": "false",
      "alt_text": "Laundry room with multiple washers and dryers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/034323/6a2c7d7a497fd5.48784980569.jpg"
    },
    {
      "id": "ec_8b1319d360fbda025c024002",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8c-062c-7558-953b-18f39e566d33.webp",
      "image_media": {
        "alt_text": "Mailboxes and laundry room with washers and dryers.",
        "public_id": "019f8a8c-062c-7558-953b-18f39e566d33",
        "storage_key": "property/6767906449167028/019f8a8c-062c-7558-953b-18f39e566d33.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient mailroom with ample mailboxes and on-site laundry facilities equipped with washers and dryers for resident use.",
      "link": "false",
      "alt_text": "Mailboxes and laundry room with washers and dryers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/034326/6a2c7d7c6053f8.36015478358.jpg"
    },
    {
      "id": "ec_4335867ff7a252fe4b83745e",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019ebf8e-2b5d-7419-88e2-a4718adaff62.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool with lounge chairs and umbrellas.",
        "public_id": "019ebf8e-2b5d-7419-88e2-a4718adaff62",
        "storage_key": "property/6767906449167028/019ebf8e-2b5d-7419-88e2-a4718adaff62.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, complete with comfortable lounge chairs and chic umbrellas, offering a perfect oasis for relaxation and enjoyment.",
      "link": "false",
      "alt_text": "Aerial view of a swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033754/6a2c7c311b4bf9.99162676931.jpg"
    },
    {
      "id": "ec_6b7ba853f65f67af373cd6ab",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019ebf8e-42a4-70db-9f8f-c9b2ae39266e.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with covered parking and a paved lot.",
        "public_id": "019ebf8e-42a4-70db-9f8f-c9b2ae39266e",
        "storage_key": "property/6767906449167028/019ebf8e-42a4-70db-9f8f-c9b2ae39266e.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover comfortable living in this apartment building featuring convenient covered parking and well-maintained grounds.",
      "link": "false",
      "alt_text": "Exterior of a modern apartment building with covered parking and a paved lot.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033752/6a2c7c2f599fe2.13994629731.jpg"
    },
    {
      "id": "ec_104105be2956d52af49629ef",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8c-0956-740f-b3c5-9b2b7fe4cda7.webp",
      "image_media": {
        "alt_text": "Aerial view of The Fletcher apartment complex with multiple buildings, parking, and a pool area.",
        "public_id": "019f8a8c-0956-740f-b3c5-9b2b7fe4cda7",
        "storage_key": "property/6767906449167028/019f8a8c-0956-740f-b3c5-9b2b7fe4cda7.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Experience comfortable living at The Fletcher, featuring modern apartments and a refreshing pool area. Enjoy convenient parking and a welcoming community atmosphere.",
      "link": "false",
      "alt_text": "Aerial view of The Fletcher apartment complex with multiple buildings, parking, and a pool area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033746/6a2c7c297fb8c8.54955100602.jpg"
    },
    {
      "id": "ec_2857b51f7b5032a6d7747741",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019ebf8e-4e7a-708a-96d8-5d1739bd88cf.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and surrounding commercial areas.",
        "public_id": "019ebf8e-4e7a-708a-96d8-5d1739bd88cf",
        "storage_key": "property/6767906449167028/019ebf8e-4e7a-708a-96d8-5d1739bd88cf.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "An aerial perspective showcasing apartment buildings with a central swimming pool, adjacent to extensive parking lots and commercial establishments, with rolling hills in the background.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings with a pool and surrounding commercial areas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033750/6a2c7c2d6d8548.19408542115.jpg"
    },
    {
      "id": "ec_d8da84f196d3996191de675a",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8c-0bf1-738b-b6f8-3bd95563c539.webp",
      "image_media": {
        "alt_text": "Aerial view of a multi-building apartment complex with white exteriors, grey roofs, and parking lots.",
        "public_id": "019f8a8c-0bf1-738b-b6f8-3bd95563c539",
        "storage_key": "property/6767906449167028/019f8a8c-0bf1-738b-b6f8-3bd95563c539.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover modern living in this apartment complex, featuring well-maintained exteriors and convenient parking. Enjoy the surrounding suburban landscape.",
      "link": "false",
      "alt_text": "Aerial view of a multi-building apartment complex with white exteriors, grey roofs, and parking lots.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033748/6a2c7c2b8a73a0.65873844254.jpg"
    },
    {
      "id": "ec_061438b39218d0c410494a1a",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8c-0f6b-7739-907b-6766adf28188.webp",
      "image_media": {
        "alt_text": "Living room with beige sofa, armchairs, coffee table, and artwork.",
        "public_id": "019f8a8c-0f6b-7739-907b-6766adf28188",
        "storage_key": "property/6767906449167028/019f8a8c-0f6b-7739-907b-6766adf28188.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Spacious living room featuring comfortable seating, modern decor, and natural light.",
      "link": "false",
      "alt_text": "Living room with beige sofa, armchairs, coffee table, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/07/16/084626/6a58eec2051736.67050486738.png"
    },
    {
      "id": "ec_62e725e28f846a7a52546afd",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f6e93-899e-70ea-99f9-a279096b34ee.webp",
      "image_media": {
        "alt_text": "Living room and dining area with modern furniture, hardwood floors, and access to a patio.",
        "public_id": "019f6e93-899e-70ea-99f9-a279096b34ee",
        "storage_key": "property/6767906449167028/019f6e93-899e-70ea-99f9-a279096b34ee.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring modern furnishings, elegant hardwood-style flooring, and direct patio access, creating a comfortable and stylish living space.",
      "link": "false",
      "alt_text": "Living room and dining area with modern furniture, hardwood floors, and access to a patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/07/16/084627/6a58eec365fce1.83213926329.png"
    },
    {
      "id": "ec_a491ce0dfe8e2927a31f29c5",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8c-1dd3-741d-8403-da94ee6617b9.webp",
      "image_media": {
        "alt_text": "Living and dining area with kitchen bar seating.",
        "public_id": "019f8a8c-1dd3-741d-8403-da94ee6617b9",
        "storage_key": "property/6767906449167028/019f8a8c-1dd3-741d-8403-da94ee6617b9.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Enjoy this open-concept living and dining area, complete with a modern kitchen and bar seating perfect for entertaining.",
      "link": "false",
      "alt_text": "Living and dining area with kitchen bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/07/16/084628/6a58eec464fe57.18697007764.png"
    },
    {
      "id": "ec_9bf90a0e05162816dc9e8705",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8c-2663-7284-aa9c-ef30f3228fab.webp",
      "image_media": {
        "alt_text": "View of a kitchen and living room area with a sink, island, dining table, and seating.",
        "public_id": "019f8a8c-2663-7284-aa9c-ef30f3228fab",
        "storage_key": "property/6767906449167028/019f8a8c-2663-7284-aa9c-ef30f3228fab.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed apartment, featuring a modern kitchen with a sleek sink and island, seamlessly flowing into a spacious living and dining area perfect for entertaining.",
      "link": "false",
      "alt_text": "View of a kitchen and living room area with a sink, island, dining table, and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/07/16/084630/6a58eec573a135.94498891280.png"
    },
    {
      "id": "ec_b2a25f3bf2a69431ae6397a0",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8c-2783-7275-80ca-7c0b916e7c5b.webp",
      "image_media": {
        "alt_text": "A digitally enhanced image of a bedroom with a large bed, nightstands, and artwork on the wall.",
        "public_id": "019f8a8c-2783-7275-80ca-7c0b916e7c5b",
        "storage_key": "property/6767906449167028/019f8a8c-2783-7275-80ca-7c0b916e7c5b.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Spacious and elegantly appointed bedroom featuring a comfortable bed, stylish nightstands, and decorative artwork. This room offers a serene retreat for relaxation.",
      "link": "false",
      "alt_text": "A digitally enhanced image of a bedroom with a large bed, nightstands, and artwork on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/07/16/084631/6a58eec6706518.14501978267.png"
    },
    {
      "id": "ec_eedd1ef4e6385e46df020088",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8c-2d12-7498-a137-91c7a4daa934.webp",
      "image_media": {
        "alt_text": "Private patio with a dog house, outdoor grill, and seating area.",
        "public_id": "019f8a8c-2d12-7498-a137-91c7a4daa934",
        "storage_key": "property/6767906449167028/019f8a8c-2d12-7498-a137-91c7a4daa934.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy your own private outdoor space with a dog house, barbecue grill, and comfortable seating, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Private patio with a dog house, outdoor grill, and seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/07/16/084632/6a58eec7944621.21289525870.png"
    },
    {
      "id": "ec_f905b1ec6c5264db8f54bc33",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f8a8c-353d-737a-90bc-a17e577d9cce.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, mounted TV, and a dresser with a mirrored closet.",
        "public_id": "019f8a8c-353d-737a-90bc-a17e577d9cce",
        "storage_key": "property/6767906449167028/019f8a8c-353d-737a-90bc-a17e577d9cce.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a modern dresser with a mounted television, and a mirrored closet for ample storage.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, mounted TV, and a dresser with a mirrored closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/07/16/084633/6a58eec8adbdc0.42727861330.png"
    },
    {
      "id": "ec_5b661f5071425e63a82c96f7",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019f6e93-b062-742a-a5c8-cbd472e04d65.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, chrome faucet, and large mirror.",
        "public_id": "019f6e93-b062-742a-a5c8-cbd472e04d65",
        "storage_key": "property/6767906449167028/019f6e93-b062-742a-a5c8-cbd472e04d65.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Step into comfort with this modern bathroom featuring a sleek white vanity, ample counter space, and a spacious mirror, perfect for your daily routine.",
      "link": "false",
      "alt_text": "Modern bathroom with white vanity, chrome faucet, and large mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/07/16/084634/6a58eec9bbd4f0.73479999583.png"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_ca58ba75-d5a1-4eb3-a319-b2079f60577a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Mal Al Sham",
      "poi_type": "Restaurants",
      "poi_address": "388 E Main St, El Cajon, CA 92020, USA",
      "poi_short_description": "Laid-back venue spotlighting Middle Eastern cuisine in an expansive space that has outdoor seating.",
      "poi_long_description": "People say this Mediterranean restaurant serves delicious and authentic Arabic food, including beef kabobs, chicken tikka, and shawarma. They also highlight the generous portions, fast service, and friendly staff.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-b2ba-7738-8cf1-36ad639bf96b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-b2ba-7738-8cf1-36ad639bf96b",
        "storage_key": "property/6767906449167028/019d08bd-b2ba-7738-8cf1-36ad639bf96b.webp",
        "width": 1182,
        "height": 828
      },
      "poi_business_url": "http://www.malalsham.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9803083134280099482&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mal-al-sham",
      "poi_latitude": "32.7952789",
      "poi_longitude": "-116.9575213",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 619-401-1055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-5ed1-76bf-b26c-fb4f338acea3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-5ed1-76bf-b26c-fb4f338acea3",
        "storage_key": "property/6767906449167028/019d08bd-5ed1-76bf-b26c-fb4f338acea3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwcFd0q1Z2YARmmZj8iuMC4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_ec9038b8-79d1-4f87-930e-64ec72f2ad2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "7160 Broadway, Lemon Grove, CA 91945, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "Diners say this hamburger restaurant serves delicious cheeseburgers, grilled onions, and animal style fries. They also highlight the friendly staff, fast service, and affordable prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-b463-7057-af59-e516d3bff353.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-b463-7057-af59-e516d3bff353",
        "storage_key": "property/6767906449167028/019d08bd-b463-7057-af59-e516d3bff353.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.in-n-out.com/57",
      "poi_directions_map_url": "https://maps.google.com/?cid=16058633511255180958&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "32.7442136",
      "poi_longitude": "-117.0432328",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-5ed1-76bf-b26c-fb4f338acea3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-5ed1-76bf-b26c-fb4f338acea3",
        "storage_key": "property/6767906449167028/019d08bd-5ed1-76bf-b26c-fb4f338acea3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi0PMkdJW2YARnoaMoBi6294",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_a5c56529-d6fd-4733-9f1a-ce6843f13f1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "8867 Cuyamaca St, Santee, CA 92071, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, chicken sandwiches, and coleslaw. They also highlight the quick service, calm atmosphere, and addictive sauce.\n\nOther reviews mention the fries can be limp.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-b2c6-72c6-9d53-1d31455e1e78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-b2c6-72c6-9d53-1d31455e1e78",
        "storage_key": "property/6767906449167028/019d08bd-b2c6-72c6-9d53-1d31455e1e78.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ca/santee/8867-cuyamaca-st.",
      "poi_directions_map_url": "https://maps.google.com/?cid=502923148385704277&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "32.8378842",
      "poi_longitude": "-116.9832194",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 619-449-0565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-5ed1-76bf-b26c-fb4f338acea3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-5ed1-76bf-b26c-fb4f338acea3",
        "storage_key": "property/6767906449167028/019d08bd-5ed1-76bf-b26c-fb4f338acea3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDwRQBY2YARVdnZWPC9-gY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_88af996e-cd0d-427e-a67b-8342374c272e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "103 Fletcher Pkwy, El Cajon, CA 92020, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and fried pickles. They also highlight the fun atmosphere, attentive staff, and quick service.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-bae2-7063-826e-dd150312035a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-bae2-7063-826e-dd150312035a",
        "storage_key": "property/6767906449167028/019d08bd-bae2-7063-826e-dd150312035a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/california/el-cajon?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=14958685684856854999&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "32.8073156",
      "poi_longitude": "-116.9640072",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 619-396-2480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-5ed1-76bf-b26c-fb4f338acea3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-5ed1-76bf-b26c-fb4f338acea3",
        "storage_key": "property/6767906449167028/019d08bd-5ed1-76bf-b26c-fb4f338acea3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1z-dghhZ2YAR1xmdOGDtl88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_8b92547d-42bf-4659-b966-6b240fb51007",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "2149 Fenton Pkwy, San Diego, CA 92108, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "People say this furniture store offers a wide variety of home furnishings, including stylish and affordable furniture, decor, and kitchenware, with a cafeteria that serves tasty Swedish treats. They also highlight the store's well-stocked and clean environment, easy navigation, friendly and helpful staff, and ample parking.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-bb08-770c-9d5a-e85e0951a057.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-bb08-770c-9d5a-e85e0951a057",
        "storage_key": "property/6767906449167028/019d08bd-bb08-770c-9d5a-e85e0951a057.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/san-diego/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=san-diego",
      "poi_directions_map_url": "https://maps.google.com/?cid=12805901528794216427&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "32.7802228",
      "poi_longitude": "-117.1263415",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-662b-7468-a098-1cbe20be0f2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-662b-7468-a098-1cbe20be0f2c",
        "storage_key": "property/6767906449167028/019d08bd-662b-7468-a098-1cbe20be0f2c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJO1rpVadV2YAR6zdphJezt7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_41483332-a39c-43fb-999b-0779556d68d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Parkway Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "415 Fletcher Pkwy, El Cajon, CA 92020, USA",
      "poi_short_description": "Mall with department stores, restaurants, movie theater & family amenities like a 2-level carousel.",
      "poi_long_description": "People say this shopping center has a good food court with lots of options, a decent variety of stores, and a movie theater. They also highlight the ample parking and the clean, polished indoor environment.\n\nSome reviews mention the mall can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-bd9e-75ab-b5ef-de6e5c7a692f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-bd9e-75ab-b5ef-de6e5c7a692f",
        "storage_key": "property/6767906449167028/019d08bd-bd9e-75ab-b5ef-de6e5c7a692f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.visitparkwayplaza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13756654316737469463&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "parkway-plaza",
      "poi_latitude": "32.8054517",
      "poi_longitude": "-116.9671883",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 619-579-9932",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-662b-7468-a098-1cbe20be0f2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-662b-7468-a098-1cbe20be0f2c",
        "storage_key": "property/6767906449167028/019d08bd-662b-7468-a098-1cbe20be0f2c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJc9jChzNY2YARFxz7Fjd06b4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_2401b680-d23e-4900-a2eb-a720af2c9451",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "5495 Grossmont Center Dr, La Mesa, CA 91942, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers unique items, fresh produce, and a wide selection of snacks, drinks, and pre-made foods. They highlight the good prices, fun finds, and the friendly, helpful staff. They also like the welcoming atmosphere and the fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bc-dc9e-73d9-9f9c-056c01441f11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-dc9e-73d9-9f9c-056c01441f11",
        "storage_key": "property/6767906449167028/019d08bc-dc9e-73d9-9f9c-056c01441f11.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/ca/la-mesa/24/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15093199335934074201&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "32.7792966",
      "poi_longitude": "-117.0056147",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 619-466-0105",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-5e97-76b8-bd87-dfdc5c3540c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-5e97-76b8-bd87-dfdc5c3540c0",
        "storage_key": "property/6767906449167028/019d08bd-5e97-76b8-bd87-dfdc5c3540c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ21ukVmxX2YARWR2DLtTQddE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e0b02d9b-e570-44fb-8964-a5402ba8853a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "298 Fletcher Pkwy, El Cajon, CA 92020, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of tools, appliances, and gardening supplies. They also highlight the friendly and helpful staff, and the well-organized layout.\n\nSome reviews mention the store can be busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-bb1e-7433-9614-cfb1d2315313.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-bb1e-7433-9614-cfb1d2315313",
        "storage_key": "property/6767906449167028/019d08bd-bb1e-7433-9614-cfb1d2315313.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/El-Cajon/CA/El-Cajon/92020/1848?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6407354708567630055&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "32.8093292",
      "poi_longitude": "-116.9647529",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 619-401-6610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-662b-7468-a098-1cbe20be0f2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-662b-7468-a098-1cbe20be0f2c",
        "storage_key": "property/6767906449167028/019d08bd-662b-7468-a098-1cbe20be0f2c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBW8V9jZY2YAR56AZ6ih_61g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_d7dd3989-034a-481d-a5a1-3f9f08f77852",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "San Diego State University",
      "poi_type": "Education",
      "poi_address": "5500 Campanile Dr, San Diego, CA 92182, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bc-fc54-735b-b81c-14fc2015cc05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-fc54-735b-b81c-14fc2015cc05",
        "storage_key": "property/6767906449167028/019d08bc-fc54-735b-b81c-14fc2015cc05.webp",
        "width": 1125,
        "height": 1074
      },
      "poi_business_url": "http://www.sdsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14096032391797864726&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "san-diego-state-university",
      "poi_latitude": "32.77641210000001",
      "poi_longitude": "-117.0719191",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 619-594-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6630-7469-a067-fbf2ff576088.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6630-7469-a067-fbf2ff576088",
        "storage_key": "property/6767906449167028/019d08bd-6630-7469-a067-fbf2ff576088.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIUqgpoZW2YARFvmCv8Yqn8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d927f34f-ec43-4ff0-b490-e5fd18d6f0b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Grossmont College",
      "poi_type": "Education",
      "poi_address": "8800 Grossmont College Dr, El Cajon, CA 92020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bc-fb32-70cc-920b-867ec1eba834.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-fb32-70cc-920b-867ec1eba834",
        "storage_key": "property/6767906449167028/019d08bc-fb32-70cc-920b-867ec1eba834.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://www.grossmont.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8825233813808899569&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "grossmont-college",
      "poi_latitude": "32.8166735",
      "poi_longitude": "-117.0065725",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 619-644-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6630-7469-a067-fbf2ff576088.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6630-7469-a067-fbf2ff576088",
        "storage_key": "property/6767906449167028/019d08bd-6630-7469-a067-fbf2ff576088.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ71G4qutX2YAR8WXYQ2WHeXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4bb3182b-b800-41d2-9fbd-d4656356a928",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Cuyamaca College",
      "poi_type": "Education",
      "poi_address": "900 Rancho San Diego Pkwy, El Cajon, CA 92019, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-c4e5-721e-bee6-4fcd55d17a0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-c4e5-721e-bee6-4fcd55d17a0a",
        "storage_key": "property/6767906449167028/019d08bd-c4e5-721e-bee6-4fcd55d17a0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cuyamaca.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3573497578494242093&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cuyamaca-college",
      "poi_latitude": "32.7446539",
      "poi_longitude": "-116.9404423",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 619-660-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6630-7469-a067-fbf2ff576088.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6630-7469-a067-fbf2ff576088",
        "storage_key": "property/6767906449167028/019d08bd-6630-7469-a067-fbf2ff576088.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKy05mkpa2YARLS3eSx2dlzE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_24a9a192-377a-4019-8904-37dd88b927c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Snapdragon Stadium",
      "poi_type": "Entertainment",
      "poi_address": "2101 Stadium Wy, San Diego, CA 92108, USA",
      "poi_short_description": "Open-air stadium accommodating football, rugby and women's soccer games as well as concerts.",
      "poi_long_description": "People say this stadium offers a good selection of food options and the food is very good for stadium food. They also highlight the beautiful and clean venue, and the great atmosphere with good views from every seat.\n\nSome reviews mention the traffic can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-c421-721e-b7f9-cd647e69ca19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-c421-721e-b7f9-cd647e69ca19",
        "storage_key": "property/6767906449167028/019d08bd-c421-721e-b7f9-cd647e69ca19.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://snapdragonstadium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9833790300765105489&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "snapdragon-stadium",
      "poi_latitude": "32.7841307",
      "poi_longitude": "-117.1224366",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-fb71-70a9-bf3d-2a374915b448.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-fb71-70a9-bf3d-2a374915b448",
        "storage_key": "property/6767906449167028/019d08bd-fb71-70a9-bf3d-2a374915b448.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ15v_AMRV2YARUS3JSC2keIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_1f236641-a119-44a4-9611-fc23d02f153c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Viejas Arena",
      "poi_type": "Entertainment",
      "poi_address": "5500 Canyon Crest Dr, San Diego, CA 92182, USA",
      "poi_short_description": "12,000+ capacity venue for sports, concerts & events on the San Diego State University campus.",
      "poi_long_description": "People say this arena is a great venue for concerts and basketball games, offering comfortable seating and decent views from all sections. They highlight the fun and energetic atmosphere, especially during games, and the helpful and friendly staff. They also like the easy access and convenient parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-c4b7-74ac-8586-f8870e67c758.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-c4b7-74ac-8586-f8870e67c758",
        "storage_key": "property/6767906449167028/019d08bd-c4b7-74ac-8586-f8870e67c758.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://as.sdsu.edu/viejas_arena/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5659767995776599249&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "viejas-arena",
      "poi_latitude": "32.7740276",
      "poi_longitude": "-117.0746442",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 619-594-0234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6d8c-7079-8b52-95fbf3b58e99",
        "storage_key": "property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJASLBHoFW2YAR0YRjYwGJi04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_037a5a82-fa64-4d8b-a2de-522a4fc9e2f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Old Mission Dam",
      "poi_type": "Entertainment",
      "poi_address": "1 Father Junipero Serra Trail, San Diego, CA 92119, USA",
      "poi_short_description": "Beautiful park and historical site with easy paths, picnic spots and wildlife.",
      "poi_long_description": "Visitors say this historical landmark offers many hiking trails, perfect for walking, running, or mountain biking, and features historical and ecological plaques. They also highlight its natural beauty, providing a sense of being out of the city despite its proximity.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-c4b6-709c-a883-b01910f0719d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-c4b6-709c-a883-b01910f0719d",
        "storage_key": "property/6767906449167028/019d08bd-c4b6-709c-a883-b01910f0719d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://mtrp.org/old-mission-dam/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13363065097463894340&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "old-mission-dam",
      "poi_latitude": "32.8395246",
      "poi_longitude": "-117.0431602",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 619-668-3281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6d8c-7079-8b52-95fbf3b58e99",
        "storage_key": "property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbRitrpv924ARRJHB1Ockc7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_9723c6c7-46ea-40e2-b596-0a689283995e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Tony Gwynn Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Plaza Deportes, San Diego, CA 92182, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-cd06-7389-9fe1-243f7bdf21bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-cd06-7389-9fe1-243f7bdf21bd",
        "storage_key": "property/6767906449167028/019d08bd-cd06-7389-9fe1-243f7bdf21bd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sdsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8539833516950893714&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tony-gwynn-stadium",
      "poi_latitude": "32.774026",
      "poi_longitude": "-117.0788554",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 619-594-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-fb71-70a9-bf3d-2a374915b448.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-fb71-70a9-bf3d-2a374915b448",
        "storage_key": "property/6767906449167028/019d08bd-fb71-70a9-bf3d-2a374915b448.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgZ3mPIBW2YARkjTVclaVg3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_b52d3d77-3666-4cbc-b6a9-572d6cf2776f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "San Diego Air & Space Museum Gillespie Field Annex",
      "poi_type": "Entertainment",
      "poi_address": "335 Kenney St, El Cajon, CA 92020, USA",
      "poi_short_description": "This museum dedicated to aviation & space technology boasts a number of models & restored aircraft.",
      "poi_long_description": "This museum dedicated to aviation & space technology boasts a number of models & restored aircraft.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-ce00-776a-a448-e90b643ebbda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-ce00-776a-a448-e90b643ebbda",
        "storage_key": "property/6767906449167028/019d08bd-ce00-776a-a448-e90b643ebbda.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sandiegoairandspace.org/museum/gillespie-field-annex",
      "poi_directions_map_url": "https://maps.google.com/?cid=11119185047513543873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "san-diego-air--space-museum-gillespie-field-annex",
      "poi_latitude": "32.8288213",
      "poi_longitude": "-116.9659343",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 619-258-1221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6d04-7623-80c2-6cbf8ea0a859.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6d04-7623-80c2-6cbf8ea0a859",
        "storage_key": "property/6767906449167028/019d08bd-6d04-7623-80c2-6cbf8ea0a859.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJsRTClBNY2YARwTThhONHT5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_eb00e8f7-0413-4316-968a-f01135437402",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Copley-Price Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "4300 El Cajon Blvd, San Diego, CA 92105, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-cd06-7389-9fe1-20ad66916063.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-cd06-7389-9fe1-20ad66916063",
        "storage_key": "property/6767906449167028/019d08bd-cd06-7389-9fe1-20ad66916063.webp",
        "width": 820,
        "height": 340
      },
      "poi_business_url": "https://www.ymcasd.org/locations/copley-price-family-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=3796442856132178256&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "copley-price-family-ymca",
      "poi_latitude": "32.7554681",
      "poi_longitude": "-117.1013753",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 619-280-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6d8c-7079-8b52-95fbf3b58e99",
        "storage_key": "property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy6EgvmlU2YARUPHTyamsrzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_034023e6-b7e1-4264-98a3-b843b68deb56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6501 University Ave, San Diego, CA 92115, USA",
      "poi_short_description": "Chain gym in Rolando Plaza with a variety of equipment, tanning, and massage options.",
      "poi_long_description": "People say this gym has a lot of machines and equipment, and is spacious. They also highlight the clean and pleasant atmosphere, and the friendly staff.\n\nOther reviews mention the hours can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-d482-711e-b2e9-5cd9c7bbc65f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-d482-711e-b2e9-5cd9c7bbc65f",
        "storage_key": "property/6767906449167028/019d08bd-d482-711e-b2e9-5cd9c7bbc65f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/san-diego-university-ave-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=5873513020174865927&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.7547647",
      "poi_longitude": "-117.0562505",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 619-550-5808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6d8c-7079-8b52-95fbf3b58e99",
        "storage_key": "property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhRCcVL9W2YARB5Yn__joglE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1d53905d-dd90-4a6b-ac5f-620eeb4ec4b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8876 Navajo Rd, San Diego, CA 92119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-d3f0-776d-8112-ba2e43c5b614.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-d3f0-776d-8112-ba2e43c5b614",
        "storage_key": "property/6767906449167028/019d08bd-d3f0-776d-8112-ba2e43c5b614.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/san-diego-ca/navajo-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=14924018015794243139&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "32.804042",
      "poi_longitude": "-117.0064884",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 619-916-0336",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6d8c-7079-8b52-95fbf3b58e99",
        "storage_key": "property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqSMKoDJX2YARQybyhFDDHM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2f7b6589-1407-41be-902f-66fcf5549f5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5500 Grossmont Center Dr, La Mesa, CA 91942, USA",
      "poi_short_description": "Spotless gym facility featuring free weights, machines, cardio equipment, tanning beds and saunas, plus group classes, personal training and massage chairs.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, machines, and functional training items, as well as amenities like saunas, massage chairs, and tanning. They also highlight the clean facilities, friendly and helpful staff, and welcoming atmosphere.\n\nSome reviews mention the classes can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-23bc-73c4-82c4-870ccea3c36d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-23bc-73c4-82c4-870ccea3c36d",
        "storage_key": "property/6767906449167028/019d08bd-23bc-73c4-82c4-870ccea3c36d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/ca/la-mesa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5238529357656100914&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "32.7764938",
      "poi_longitude": "-117.0114144",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 619-741-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6d8c-7079-8b52-95fbf3b58e99",
        "storage_key": "property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDz1qQhJX2YARMhCMJLL-skg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9f91802e-73a8-4ee8-906d-2806e7068f1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Cameron Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "10123 Riverwalk Dr, Santee, CA 92071, USA",
      "poi_short_description": "Gym with a clean and modern workout room, plus a gym, outdoor splash pool with a waterslide (some say the slides are out of order) and a kiddie pool (closed at one point).",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-cd06-7389-9fe1-20ad66916063.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-cd06-7389-9fe1-20ad66916063",
        "storage_key": "property/6767906449167028/019d08bd-cd06-7389-9fe1-20ad66916063.webp",
        "width": 820,
        "height": 340
      },
      "poi_business_url": "https://www.ymcasd.org/locations/cameron-family-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=15201008792596359965&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cameron-family-ymca",
      "poi_latitude": "32.8508498",
      "poi_longitude": "-116.9777585",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 619-449-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6d8c-7079-8b52-95fbf3b58e99",
        "storage_key": "property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO_QRkD5a2YARHatLXvXU9NI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_22ea60b7-0363-4448-ab1f-3cd388edcbb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "McGrath Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "12006 Campo Rd, Spring Valley, CA 91978, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-d961-7549-9001-2d8cc2fd9f8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-d961-7549-9001-2d8cc2fd9f8e",
        "storage_key": "property/6767906449167028/019d08bd-d961-7549-9001-2d8cc2fd9f8e.webp",
        "width": 640,
        "height": 365
      },
      "poi_business_url": "https://www.ymcasd.org/locations/mcgrath-family-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=9007315150119117167&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mcgrath-family-ymca",
      "poi_latitude": "32.73598",
      "poi_longitude": "-116.9402183",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 619-462-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6d8c-7079-8b52-95fbf3b58e99",
        "storage_key": "property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPa-i-0xa2YARbyHY_mdpAH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_e1f5fad6-94e2-4b73-984c-0c824856dd6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Kaiser Permanente Zion Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4647 Zion Ave, San Diego, CA 92120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-dbe2-73aa-bd0e-a6765e196410.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-dbe2-73aa-bd0e-a6765e196410",
        "storage_key": "property/6767906449167028/019d08bd-dbe2-73aa-bd0e-a6765e196410.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://healthy.kaiserpermanente.org/southern-california/facilities/Kaiser-Permanente-Zion-Medical-Center-100084",
      "poi_directions_map_url": "https://maps.google.com/?cid=16884578483617548433&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kaiser-permanente-zion-medical-center",
      "poi_latitude": "32.7912322",
      "poi_longitude": "-117.09526",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 619-528-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-70c1-7433-aeff-fe44d8d8a81d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-70c1-7433-aeff-fe44d8d8a81d",
        "storage_key": "property/6767906449167028/019d08bd-70c1-7433-aeff-fe44d8d8a81d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJr80_QsJV2YARkUg6KqwSUuo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0552d94c-e4b9-4fca-ad0d-d450fbd7cded",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Sharp Grossmont Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "5555 Grossmont Center Dr, La Mesa, CA 91942, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-1456-761e-a6a3-87bf549ea4d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-1456-761e-a6a3-87bf549ea4d9",
        "storage_key": "property/6767906449167028/019d08bd-1456-761e-a6a3-87bf549ea4d9.webp",
        "width": 730,
        "height": 410
      },
      "poi_business_url": "https://www.sharp.com/locations/hospitals/sharp-grossmont?utm_source=google&utm_medium=organic&utm_campaign=yext&y_source=1_ODQ4MzMyNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10405628621323876698&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sharp-grossmont-hospital",
      "poi_latitude": "32.781125",
      "poi_longitude": "-117.0074256",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 619-740-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-70c1-7433-aeff-fe44d8d8a81d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-70c1-7433-aeff-fe44d8d8a81d",
        "storage_key": "property/6767906449167028/019d08bd-70c1-7433-aeff-fe44d8d8a81d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-718aG1X2YARWrmlhhk4aJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a1e601dd-45ad-42e4-abae-01684816a8d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Cowles Mountain Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7001 Golfcrest Dr, San Diego, CA 92119, USA",
      "poi_short_description": "Picturesque uphill hiking trail known for its panoramic views at the summit.",
      "poi_long_description": "People say this hiking area offers a challenging workout with great views. They highlight the trail is well-maintained and clearly marked, and the hike is manageable for those with solid footwork. They also like the friendly and active crowd, creating a welcoming and safe environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-dd06-75ff-85dd-651930ede2a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-dd06-75ff-85dd-651930ede2a1",
        "storage_key": "property/6767906449167028/019d08bd-dd06-75ff-85dd-651930ede2a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sandiego.gov/park-and-recreation/parks/osp/mtrails",
      "poi_directions_map_url": "https://maps.google.com/?cid=11457899975665487685&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cowles-mountain-trailhead",
      "poi_latitude": "32.8046386",
      "poi_longitude": "-117.0377579",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 619-668-3281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6b70-74ca-96a9-fe1f264cd0e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6b70-74ca-96a9-fe1f264cd0e1",
        "storage_key": "property/6767906449167028/019d08bd-6b70-74ca-96a9-fe1f264cd0e1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7dApJEpW2YARRY9_QVKjAp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_fcf4a043-2ab5-4e72-964d-976e8316a6dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Mission Trails Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1 Father Junipero Serra Trail, San Diego, CA 92119, USA",
      "poi_short_description": "8,000-acre recreational park featuring 60 miles of trails, along with a lake for boating & camping.",
      "poi_long_description": "People say this park offers a variety of hiking trails, scenic landscapes, and wildlife, providing a peaceful escape in nature. They highlight the well-marked trails, the informative visitor center, and the multiple parking lots. They also like the diverse trail options, ranging from easy walks to challenging hikes, and the beautiful views of San Diego.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-ddb8-75ec-b01b-3c91988d1bf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-ddb8-75ec-b01b-3c91988d1bf2",
        "storage_key": "property/6767906449167028/019d08bd-ddb8-75ec-b01b-3c91988d1bf2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://mtrp.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2544439939052619407&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mission-trails-regional-park",
      "poi_latitude": "32.8214576",
      "poi_longitude": "-117.0624181",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 619-668-3281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6b70-74ca-96a9-fe1f264cd0e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6b70-74ca-96a9-fe1f264cd0e1",
        "storage_key": "property/6767906449167028/019d08bd-6b70-74ca-96a9-fe1f264cd0e1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPXDC_Iv924ARj0aMv6SqTyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c2f455fa-4ca4-4efb-991f-5da5015d7d81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Santee Lakes Recreation Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9310 Fanita Pkwy, Santee, CA 92071, USA",
      "poi_short_description": "Staycation spot for locals with 7 man-made lakes for camping, boating, fishing & picnics.",
      "poi_long_description": "People say this park offers beautiful lakes, trails, fishing, camping, and family-friendly amenities like playgrounds and paddle boats. They highlight the peaceful, safe, and relaxing vibe, and the friendly and helpful staff. They also like the well-maintained grounds and clean facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-ddc1-72a8-a467-c1ea5d99e1e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-ddc1-72a8-a467-c1ea5d99e1e2",
        "storage_key": "property/6767906449167028/019d08bd-ddc1-72a8-a467-c1ea5d99e1e2.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "http://www.santeelakes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3068124483151821601&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "santee-lakes-recreation-preserve",
      "poi_latitude": "32.8461647",
      "poi_longitude": "-117.0039378",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 619-596-3141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6b70-74ca-96a9-fe1f264cd0e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6b70-74ca-96a9-fe1f264cd0e1",
        "storage_key": "property/6767906449167028/019d08bd-6b70-74ca-96a9-fe1f264cd0e1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJyRRl9z3924ARIXvxOPYqlCo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cc637eee-33dd-4953-a3e2-bba98f16a216",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Admiral Baker Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2400 Admiral Baker Rd #3604, San Diego, CA 92124, USA",
      "poi_short_description": "Naval base golf course & clubhouse offering 2 18-hole courses, plus an equipment shop & an eatery.",
      "poi_long_description": "Naval base golf course & clubhouse offering 2 18-hole courses, plus an equipment shop & an eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-e151-731d-ae1f-f0fb0471f474.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-e151-731d-ae1f-f0fb0471f474",
        "storage_key": "property/6767906449167028/019d08bd-e151-731d-ae1f-f0fb0471f474.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://navylifesw.com/sandiego/recreation/golf/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16857028103165048800&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "admiral-baker-golf-course",
      "poi_latitude": "32.8018653",
      "poi_longitude": "-117.0975138",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 619-487-0090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-fd23-7034-844b-b702b7631a35.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-fd23-7034-844b-b702b7631a35",
        "storage_key": "property/6767906449167028/019d08bd-fd23-7034-844b-b702b7631a35.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJXWBVP-tV2YAR4PftWb8x8Ok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_ed5ce562-d46a-4c39-ae15-be28288c4de4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Chollas Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6350 College Grove Dr, San Diego, CA 92115, USA",
      "poi_short_description": "Casual park with picnic tables and playgrounds, plus a lake with ducks and geese.",
      "poi_long_description": "People say this park offers a peaceful lake, walking trails, fishing, and a playground. They highlight the beautiful scenery, relaxing atmosphere, and family-friendly environment. They also like the well-maintained grounds and ample picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-e332-727b-a91b-a25f686e54b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-e332-727b-a91b-a25f686e54b1",
        "storage_key": "property/6767906449167028/019d08bd-e332-727b-a91b-a25f686e54b1.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.sandiego.gov/park-and-recreation/centers/recctr/chollas",
      "poi_directions_map_url": "https://maps.google.com/?cid=17398322719789943090&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chollas-lake-park",
      "poi_latitude": "32.7373747",
      "poi_longitude": "-117.0605242",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 619-527-7683",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6b70-74ca-96a9-fe1f264cd0e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6b70-74ca-96a9-fe1f264cd0e1",
        "storage_key": "property/6767906449167028/019d08bd-6b70-74ca-96a9-fe1f264cd0e1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8zl7IUtR2YARMgmwWFVCc_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_67d9e724-abc2-4800-a2a1-7504981f01e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "SDSU Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Diego, CA 92182, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-e488-73e1-ad07-183d1acf0c92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-e488-73e1-ad07-183d1acf0c92",
        "storage_key": "property/6767906449167028/019d08bd-e488-73e1-ad07-183d1acf0c92.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7338960994505490894&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sdsu-station",
      "poi_latitude": "32.7733253",
      "poi_longitude": "-117.0705252",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6d8c-7079-8b52-95fbf3b58e99",
        "storage_key": "property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZcnZiYZW2YARzoHyGSQ62WU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_7f335258-1eee-4218-917e-242918d7b963",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Lemon Grove Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "Lemon Grove, CA 91945, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-e4fb-766c-9dd7-be974ec4114b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-e4fb-766c-9dd7-be974ec4114b",
        "storage_key": "property/6767906449167028/019d08bd-e4fb-766c-9dd7-be974ec4114b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3193545242066674856&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lemon-grove-depot",
      "poi_latitude": "32.7434239",
      "poi_longitude": "-117.0306589",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6d8c-7079-8b52-95fbf3b58e99",
        "storage_key": "property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZtTEtVQ2YARqOSFP3rAUSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_78918855-ef6f-484e-9e53-4902522e381e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Gillespie Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "1960 Joe Crosson Dr, El Cajon, CA 92020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-ebdc-748f-8d0a-a3771b5bc8be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-ebdc-748f-8d0a-a3771b5bc8be",
        "storage_key": "property/6767906449167028/019d08bd-ebdc-748f-8d0a-a3771b5bc8be.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sandiegocounty.gov/content/sdc/dpw/airports/gillespie.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11879975809839881657&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gillespie-field",
      "poi_latitude": "32.8255462",
      "poi_longitude": "-116.9745483",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 619-956-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-7239-71ad-a3ac-a0c78fdd1e23.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-7239-71ad-a3ac-a0c78fdd1e23",
        "storage_key": "property/6767906449167028/019d08bd-7239-71ad-a3ac-a0c78fdd1e23.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJvyIWghdY2YARuV29ZQ4n3qQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_4b057818-bbc7-4cc1-a7de-82a471c72046",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Amaya Trolley Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "La Mesa, CA 91942, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-3ffa-73c9-9a2e-4968c77d2eb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-3ffa-73c9-9a2e-4968c77d2eb7",
        "storage_key": "property/6767906449167028/019d08bd-3ffa-73c9-9a2e-4968c77d2eb7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4591872811854924552&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amaya-trolley-station",
      "poi_latitude": "32.785496",
      "poi_longitude": "-117.001785",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6d8c-7079-8b52-95fbf3b58e99",
        "storage_key": "property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYbFGnHFX2YARCAtjXP6buT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_37e3752e-77c1-4fa6-a3cc-cc50363bef9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Stadium",
      "poi_type": "Transportation & Transit",
      "poi_address": "9449 Friars Rd, San Diego, CA 92108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-ebf0-7713-9230-299a32e7eff7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-ebf0-7713-9230-299a32e7eff7",
        "storage_key": "property/6767906449167028/019d08bd-ebf0-7713-9230-299a32e7eff7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sdmts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1260361112870261255&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stadium",
      "poi_latitude": "32.7809826",
      "poi_longitude": "-117.1195814",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 619-233-3004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6d8c-7079-8b52-95fbf3b58e99",
        "storage_key": "property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ98rF6aNV2YARBxJZJcGzfRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_71de6dc1-beb9-4030-b969-bcc45ea8278e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "EDCO Customer Service Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6670 Federal Blvd, Lemon Grove, CA 91945, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-ec13-7778-b8c9-00813c82a5fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-ec13-7778-b8c9-00813c82a5fb",
        "storage_key": "property/6767906449167028/019d08bd-ec13-7778-b8c9-00813c82a5fb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.edcodisposal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7170573906145066245&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edco-customer-service-office",
      "poi_latitude": "32.7361267",
      "poi_longitude": "-117.0551337",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 619-287-7555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6d8c-7079-8b52-95fbf3b58e99",
        "storage_key": "property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe4kYDzVR2YARBT127_n-gmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9f332182-12a4-490f-bedf-e047f305701b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "Sigler wholesale distributors",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1900 Weld Blvd STE 140, El Cajon, CA 92020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-edc8-7099-8e11-746edf132000.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-edc8-7099-8e11-746edf132000",
        "storage_key": "property/6767906449167028/019d08bd-edc8-7099-8e11-746edf132000.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.siglers.com/el-cajon",
      "poi_directions_map_url": "https://maps.google.com/?cid=4993251269976703205&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sigler-wholesale-distributors",
      "poi_latitude": "32.8280463",
      "poi_longitude": "-116.988735",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 619-202-1154",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6d8c-7079-8b52-95fbf3b58e99",
        "storage_key": "property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnbuGY_dX2YAR5cA6HZOXS0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_58f19f0a-c67d-463d-9fef-652b31bf0ab5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "La Mesa City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8130 Allison Ave, La Mesa, CA 91942, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-5198-7469-a296-5b0601169845.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-5198-7469-a296-5b0601169845",
        "storage_key": "property/6767906449167028/019d08bd-5198-7469-a296-5b0601169845.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.cityoflamesa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2777568113799702240&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-mesa-city-hall",
      "poi_latitude": "32.7662173",
      "poi_longitude": "-117.0227275",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 619-463-6611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-7238-74c8-8a3f-d2f85c116b32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-7238-74c8-8a3f-d2f85c116b32",
        "storage_key": "property/6767906449167028/019d08bd-7238-74c8-8a3f-d2f85c116b32.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA7wF7iJX2YAR4KZ7unvniyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_4c710793-ecb9-4710-970d-0a241f226943",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "PriceSmart, Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9797 Aero Dr, San Diego, CA 92123, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-f2cf-704d-8ef5-7e7dd8a3b2d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-f2cf-704d-8ef5-7e7dd8a3b2d1",
        "storage_key": "property/6767906449167028/019d08bd-f2cf-704d-8ef5-7e7dd8a3b2d1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pricesmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=925535117001250045&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pricesmart-inc",
      "poi_latitude": "32.8085063",
      "poi_longitude": "-117.118248",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 858-404-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6d8c-7079-8b52-95fbf3b58e99",
        "storage_key": "property/6767906449167028/019d08bd-6d8c-7079-8b52-95fbf3b58e99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvaqnoBYH3IAR_VQCBEkp2Aw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_68cec5ee-1555-4596-aef7-94b1b9e5b757",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "poi_name": "City Of El Cajon City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 Civic Center Way, El Cajon, CA 92020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-f29c-75ee-a6ad-2879d30d602a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-f29c-75ee-a6ad-2879d30d602a",
        "storage_key": "property/6767906449167028/019d08bd-f29c-75ee-a6ad-2879d30d602a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cityofelcajon.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14807106690978313224&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-el-cajon-city-hall",
      "poi_latitude": "32.7964872",
      "poi_longitude": "-116.9598502",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 619-441-1726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bd-7238-74c8-8a3f-d2f85c116b32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-7238-74c8-8a3f-d2f85c116b32",
        "storage_key": "property/6767906449167028/019d08bd-7238-74c8-8a3f-d2f85c116b32.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5WQlPLZZ2YARCHQSgxVpfc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "ec_58f28161c3c8ddbb5d0ce187",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_9e7f62f6cedad0943d856d39",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_62aabf698e92e11adefc67cb",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_946e32f0f5c9471fad140130",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_beb68b441a51a87ce6ba63e3",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_2f57c733-b87a-4314-bfe4-99b3544f4e3b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "rating": "5.0",
      "name": "Drew Beaurline",
      "text": "This property is great and love the management team!",
      "date": "2026-01-30",
      "title": ""
    },
    {
      "id": "custom_ce68278b-76ce-4b8d-954a-5772104bc2fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "rating": "5.0",
      "name": "Marci Applegate",
      "text": "Repair was completed the same day I reported my issue.",
      "date": "2026-02-18",
      "title": ""
    },
    {
      "id": "custom_e6945de5-a8cf-4815-85f2-74043c32abc1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "rating": "5.0",
      "name": "Erendira Hernandez",
      "text": "My family and I have been living here for over 2 years now the communication between management and tenants is great and excellent location near freeways.",
      "date": "2026-05-16",
      "title": ""
    },
    {
      "id": "custom_df4f52a0-0154-4787-b8bf-a7d03261da2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "rating": "5.0",
      "name": " Regina Davis",
      "text": "Whenever I have any maintenance issues they are handled with professional assistance and promptly",
      "date": "2026-10-13",
      "title": ""
    },
    {
      "id": "custom_0d564b29-c1f6-403a-8f34-25838332424d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "rating": "5.0",
      "name": " Kayla Saint-Fleur",
      "text": "I was having a horrible experience with a different apartment that I needed to find a new place to live in short notice. The Fletcher (Gabby the manager) was beyond professional, super fast responding to calls and emails, were able to assist me quickly in short notice.\n\nThe move in process was flawless and the apartment was gorgeous in ready as they stated it would be. 10/10 experience and the location is spectacular. The new upgrades are amazing too.",
      "date": "2026-08-18",
      "title": ""
    },
    {
      "id": "custom_97808cc5-7806-4001-bf0f-e52781c2e309",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "rating": "5.0",
      "name": "l pascual",
      "text": "I really like where we live and I do hope no big changes come around as well as rent payment do NOT increase.\n",
      "date": "2026-08-17",
      "title": ""
    },
    {
      "id": "custom_ab1b919c-595b-42d9-b326-4cf87ffc6a2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "rating": "5.0",
      "name": " Grace Cole",
      "text": "The maintenance workers at The Fletcher Apartment Complex are excellent. My maintenance request was addressed the same day it was requested, and the job was completed the very next day. The maintenance worker was on time as promised, friendly, courteous, left the work area very clean, and the issue was resolved.\n",
      "date": "2026-07-13",
      "title": ""
    },
    {
      "id": "custom_849e37be-6470-4424-9a69-5b11b4ff9afd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "rating": "5.0",
      "name": " Grace Honore",
      "text": "While the maintenance worker is very efficient and has handled any requests in a very speedy manner I would still like to know when and if anything is going to be done to those of us with disabilities getting around. I’m walker dependent and if there’s no one around stairs I am stuck not being able to do anything. I really wish consideration is made soon via ramp or lift. My next step is total wheelchair and then there is no way for me to leave my apartment.\n\nAt present, there are NO ramp or any other assistance",
      "date": "2026-07-11",
      "title": ""
    },
    {
      "id": "custom_b4be28a4-aa4a-43ba-b61c-25dfb81beb70",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "rating": "5.0",
      "name": "Jeanette King",
      "text": "The maintenance personnel is outstanding. He is professional and very efficient.\n",
      "date": "2026-07-10",
      "title": ""
    },
    {
      "id": "custom_104fb6e4-374d-4025-a779-2762fa2373bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "rating": "5.0",
      "name": " Erendira Hernandez",
      "text": "My family and I have been living here for over 2 years now the communication between management and tenants is great and excellent location near freeways.\n",
      "date": "2026-05-19",
      "title": ""
    },
    {
      "id": "custom_7e652a7d-512c-482a-87aa-433cd24490bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "rating": "5.0",
      "name": "Abid Mozaffar",
      "text": "I've been a tenant here since 2018, and when comparing the previous Patrician Apartments management with the Fletcher, I must say that the Fletcher management has been better overall, and I'm pretty happy with them so far. Their improvements to the property have been notable and largely welcomed, and they've been very prompt in settling the work tickets that we posted on the website.\n\nA couple of improvements that I'd like to mention are: adding facility for charging EVs, and making provisions to allow tenants to route their electricity through a house inverter so they can better manage their electricity usage. With EVs becoming more mainstream, and with the rise in electric and gas costs, these imrpovements would allow tenants to better manage their living conditions considerably.",
      "date": "2026-05-19",
      "title": ""
    },
    {
      "id": "custom_0c6f5442-ec23-4693-a55a-0b61f5378512",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "rating": "5.0",
      "name": "Joanna Garcia",
      "text": "I have lived here for almost 20 years and I love living here, I feel very safe being outside at dark. The new manager Gaby has been very sweet and friendly, Josh the new maintenance person has done such a good job, I don't think the grounds have ever been so clean.",
      "date": "2026-05-18",
      "title": ""
    },
    {
      "id": "custom_e37b01b3-cc9e-4909-92e1-92c83008f0dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "rating": "5.0",
      "name": "Aleksandra Dennis",
      "text": "Submitted ticket for maintenance request as outside patio was missing light bulb. I just wanted to know what kind it was so I could put one in but they came out and installed for me. Thank you so much!\n",
      "date": "2026-04-18",
      "title": ""
    },
    {
      "id": "custom_53f82153-3264-43d0-9066-3b4c6d22e06a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "rating": "5.0",
      "name": " Drew Beaurline",
      "text": "This property is great and love the management team!\n",
      "date": "2026-10-19",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_15eb685b-d3a2-4858-8012-14fee28ffa7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d45fa-64d8-7768-a2d5-9bf806343f0c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d45fa-64d8-7768-a2d5-9bf806343f0c",
        "storage_key": "property/6767906449167028/019d45fa-64d8-7768-a2d5-9bf806343f0c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "One Bedroom with Patio",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=xJX6z4VRssH"
    },
    {
      "id": "custom_a2792632-df5d-49be-a9e0-fc3a0ea3c151",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d45fa-7ae2-74ba-a4f7-320e137ef285.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d45fa-7ae2-74ba-a4f7-320e137ef285",
        "storage_key": "property/6767906449167028/019d45fa-7ae2-74ba-a4f7-320e137ef285.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Two Bedroom Two Bathroom",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eraGKBUT8pQ"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019ecc2c-5e21-73cd-bae3-f3ea5a8c2e7c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Fletcher  Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-la-mesa",
      "search_query": "pet friendly apartments La Mesa",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in La Mesa",
      "h2_subtitle": "Discover pet inclusive homes at The Fletcher, La Mesa. Enjoy modern features and amenities designed for you and your furry friends.",
      "page_copy": "Finding a home where both you and your pets feel welcome is crucial. At The Fletcher in La Mesa, we offer pet friendly apartments designed with comfort and convenience in mind. Our renovated one- and two-bedroom floor plans include thoughtful features such as stainless steel appliances and keyless entry.<br>Beyond your front door, you'll find a community that embraces pet ownership. Explore the beautifully maintained common areas or relax by the pool while knowing your furry companions are catered for. With amenities like hard surface floors and a custom tile backsplash, keeping your living space clean and stylish is a breeze. Discover the perfect pet friendly haven at The Fletcher in La Mesa today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio area with a pergola and view of the pool and apartment buildings.",
        "public_id": "019d08bf-24f2-72bb-8d91-c3ae58742eb4",
        "storage_key": "property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in La Mesa | The Fletcher",
      "seo_description": "Find pet friendly apartments in La Mesa at The Fletcher! Enjoy modern amenities and a welcoming environment for you and your furry friend.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "generator",
      "page_item_url": "apartments-with-pool-san-diego-county",
      "search_query": "apartments with pool in San Diego County",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in San Diego County",
      "h2_subtitle": "Dive into comfort at The Fletcher in San Diego County. Experience premium living with access to our stunning community pool.",
      "page_copy": "Looking for apartments with a pool in San Diego County? The Fletcher in La Mesa offers a refreshing escape with its stunning community pool. Perfect for both relaxation and recreation, our pool area provides a serene setting to unwind, take a swim, or socialize with neighbors.<br>Our spacious one- and two-bedroom apartments feature modern amenities such as stainless steel appliances and keyless entry, complemented by our community perks. Beyond the pool, enjoy the convenience of onsite laundry facilities and a BBQ area, all within easy access to major freeways. Discover your perfect home at The Fletcher today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio area with a pergola and view of the pool and apartment buildings.",
        "public_id": "019d08bf-24f2-72bb-8d91-c3ae58742eb4",
        "storage_key": "property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in San Diego County | The Fletcher",
      "seo_description": "Explore The Fletcher's apartments with a pool in San Diego County. Enjoy modern amenities and a refreshing pool in lovely La Mesa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-near-91942",
      "search_query": "air conditioned apartments near 91942",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apts Near 91942",
      "h2_subtitle": "Stay cool at The Fletcher, perfectly located near the 91942 area. Our apartments offer comfortable living with air conditioned interiors.",
      "page_copy": "Beat the heat and find comfort at The Fletcher, conveniently located near the 91942 region in La Mesa. Our air conditioned apartments offer a refreshing retreat from the Southern California sun. Experience newly renovated spaces with one- and two-bedroom floor plans that feature modern touches like stainless steel appliances and private backyards.<br>Enjoy the communal benefits of our community pool and BBQ area while living just minutes from major freeways for easier commutes. Residents at The Fletcher benefit from spacious interiors infused with modern convenience, promising a living experience that's both cozy and stylish. Visit The Fletcher and enjoy air conditioned living in the heart of San Diego County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio area with a pergola and view of the pool and apartment buildings.",
        "public_id": "019d08bf-24f2-72bb-8d91-c3ae58742eb4",
        "storage_key": "property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near 91942 | The Fletcher",
      "seo_description": "Discover air conditioned apartments near 91942 at The Fletcher. Enjoy modern conveniences and a cool retreat in La Mesa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "generator",
      "page_item_url": "apartments-with-dedicated-parking-la-mesa",
      "search_query": "apartments with dedicated parking La Mesa",
      "category": "Amenity",
      "h1_title": "Apts with Dedicated Parking in La Mesa",
      "h2_subtitle": "Find hassle-free parking at The Fletcher in La Mesa. Enjoy the convenience of dedicated parking with modern amenities.",
      "page_copy": "Parking in La Mesa is no longer a concern when you choose The Fletcher. Offering apartments with dedicated parking, we ensure residents experience seamless access to their homes in our vibrant community. Our one- and two-bedroom apartments not only provide secure parking but also feature newly renovated interiors with stainless steel appliances.<br>Located in a prime area of San Diego County, residents of The Fletcher can enjoy community perks like a sparkling pool and a welcoming BBQ area. Our dedicated parking is complemented by modern conveniences, including keyless entry and onsite laundry facilities. Experience a lifestyle of ease and comfort at The Fletcher, with guaranteed parking and modern living spaces.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio area with a pergola and view of the pool and apartment buildings.",
        "public_id": "019d08bf-24f2-72bb-8d91-c3ae58742eb4",
        "storage_key": "property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Dedicated Parking in La Mesa | The Fletcher",
      "seo_description": "Explore The Fletcher apartments with dedicated parking in La Mesa. Enjoy hassle-free parking and modern living in our vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-in-91942",
      "search_query": "apartments with dishwasher in 91942",
      "category": "Amenity",
      "h1_title": "Apts with Dishwasher in 91942",
      "h2_subtitle": "Discover The Fletcher's modern apartments equipped with dishwashers in the 91942 area. Enjoy convenience and comfort.",
      "page_copy": "At The Fletcher, located in the heart of La Mesa's 91942 area, you'll find modern apartments thoughtfully equipped with dishwashers. Our one- and two-bedroom floor plans are designed to enhance your lifestyle with ease and value. Experience the convenience of stainless steel appliances and a dishwasher that makes daily chores a breeze.<br>Beyond the well-equipped kitchens, residents at The Fletcher enjoy an array of amenities, including our community pool and BBQ area, perfect for entertaining and relaxation. With easy access to major freeways, living in the 91942 area offers both convenience and charm. Discover a new standard of comfortable living with all the modern conveniences you desire at The Fletcher.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio area with a pergola and view of the pool and apartment buildings.",
        "public_id": "019d08bf-24f2-72bb-8d91-c3ae58742eb4",
        "storage_key": "property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Dishwasher in 91942 | The Fletcher",
      "seo_description": "Find The Fletcher apartments with dishwashers in 91942. Enjoy modern amenities and convenient living in La Mesa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-la-mesa-ca",
      "search_query": "1 bedroom apartments la mesa ca",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in La Mesa, CA",
      "h2_subtitle": "Explore modern 1-bedroom apartments at The Fletcher in La Mesa, CA. Enjoy stylish living spaces with top-notch amenities.",
      "page_copy": "Discover the appeal of The Fletcher's 1-bedroom apartments in La Mesa, CA. Our thoughtfully designed units combine modern aesthetics with practical features, offering ideal homes for individuals or couples. Each apartment boasts newly renovated interiors, complete with stainless steel appliances and hard surface floors.<br>Residents have access to community amenities such as a shimmering pool and BBQ area, complemented by the convenience of onsite laundry facilities. Located in the vibrant neighborhood of La Mesa, near major freeways, you can enjoy both the tranquility of your home and easy access to all that San Diego County has to offer. Experience the comfort and style of The Fletcher's 1-bedroom apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio area with a pergola and view of the pool and apartment buildings.",
        "public_id": "019d08bf-24f2-72bb-8d91-c3ae58742eb4",
        "storage_key": "property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in La Mesa, CA | The Fletcher",
      "seo_description": "Find stylish 1-bedroom apartments in La Mesa, CA, at The Fletcher. Enjoy modern living with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-san-diego-county",
      "search_query": "2 bedroom apartments san diego county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apts in San Diego County",
      "h2_subtitle": "Discover spacious 2-bedroom apartments at The Fletcher in the heart of San Diego County. Enjoy modern living and a vibrant community.",
      "page_copy": "The Fletcher offers spacious 2-bedroom apartments in San Diego County that blend comfort with contemporary design. Nestled in La Mesa, these units are perfect for small families or roommates, featuring newly renovated interiors highlighted by stainless steel appliances and custom tile backsplashes.<br>The community provides a range of amenities including a refreshing pool and a welcoming BBQ area, allowing residents to relax and entertain with ease. With hard surface floors and keyless entry, our apartments cater to modern living needs. Experience a blend of style and convenience at The Fletcher, located near major freeways for effortless commutes across San Diego County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio area with a pergola and view of the pool and apartment buildings.",
        "public_id": "019d08bf-24f2-72bb-8d91-c3ae58742eb4",
        "storage_key": "property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apts in San Diego County | The Fletcher",
      "seo_description": "Explore The Fletcher's 2-bedroom apartments in San Diego County. Enjoy modern amenities and a vibrant community vibe in La Mesa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "generator",
      "page_item_url": "apartments-near-san-diego-state-university",
      "search_query": "apartments near san diego state university",
      "category": "School",
      "h1_title": "Apts Near San Diego State University",
      "h2_subtitle": "Find convenient and modern apartments near San Diego State University at The Fletcher. Perfect for students and staff.",
      "page_copy": "Located just a short drive from San Diego State University, The Fletcher offers ideal living for students and faculty seeking stylish apartments near campus. Our one- and two-bedroom units feature newly renovated interiors designed for comfort and ease, including stainless steel appliances and keyless entry.<br>Residents of The Fletcher enjoy community perks like a refreshing pool and BBQ area, perfect for downtime between studies or work. With easy access to major freeways, commuting to the university or exploring nearby attractions is a breeze. Experience modern living in a convenient location at The Fletcher, your gateway to academia and relaxation in San Diego County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio area with a pergola and view of the pool and apartment buildings.",
        "public_id": "019d08bf-24f2-72bb-8d91-c3ae58742eb4",
        "storage_key": "property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near San Diego State University | The Fletcher",
      "seo_description": "Discover modern living at The Fletcher, offering apartments near San Diego State University with amenities perfect for students and staff.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "generator",
      "page_item_url": "fletcher-apartments-close-to-grossmont-college",
      "search_query": "fletcher apartments close to grossmont college",
      "category": "School",
      "h1_title": "Fletcher Apartments Near Grossmont College",
      "h2_subtitle": "Experience convenience at Fletcher Apartments, just minutes from Grossmont College. Perfect for students seeking modern living.",
      "page_copy": "The Fletcher is the ideal choice for those looking for apartments close to Grossmont College. Our one- and two-bedroom units offer a modern touch with newly renovated interiors, including stainless steel appliances and custom tile backsplashes. These features make The Fletcher a comfortable and stylish home for students and staff alike.<br>Enjoy the convenience of living near campus while taking advantage of community amenities like a pool and BBQ area. Located in La Mesa, residents benefit from proximity to major freeways, making commuting or exploring nearby San Diego County attractions effortless. Choose The Fletcher for modern apartment living near Grossmont College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio area with a pergola and view of the pool and apartment buildings.",
        "public_id": "019d08bf-24f2-72bb-8d91-c3ae58742eb4",
        "storage_key": "property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fletcher Apartments Near Grossmont College",
      "seo_description": "Find modern apartments at The Fletcher, located conveniently close to Grossmont College, perfect for students and faculty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "generator",
      "page_item_url": "la-mesa-apartments-near-cuyamaca-college",
      "search_query": "la mesa apartments near cuyamaca college",
      "category": "School",
      "h1_title": "La Mesa Apts Near Cuyamaca College",
      "h2_subtitle": "Discover comfortable living in La Mesa apartments near Cuyamaca College. Perfect for those seeking proximity and modern amenities.",
      "page_copy": "Welcome to The Fletcher, where you'll find spacious La Mesa apartments near Cuyamaca College. Our one- and two-bedroom floor plans are designed with comfort in mind, featuring stainless steel appliances, keyless entry, and private backyards. These modern interiors make The Fletcher the perfect home for students and professionals alike.<br>Our community amenities include a sparkling pool and BBQ area, providing a delightful environment for relaxation after a day at college. With easy access to major freeways, commuting to Cuyamaca College or exploring San Diego County's attractions is hassle-free. Experience the convenience and style of living at The Fletcher, ideally situated in La Mesa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio area with a pergola and view of the pool and apartment buildings.",
        "public_id": "019d08bf-24f2-72bb-8d91-c3ae58742eb4",
        "storage_key": "property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "La Mesa Apts Near Cuyamaca College | The Fletcher",
      "seo_description": "Experience stylish living at The Fletcher, offering La Mesa apartments near Cuyamaca College with modern amenities and easy commute options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "generator",
      "page_item_url": "apartments-near-kaiser-permanente-zion-medical-center",
      "search_query": "apartments near Kaiser Permanente Zion Medical Center La Mesa",
      "category": "Hospital",
      "h1_title": "Apts Near Kaiser Zion Medical Center",
      "h2_subtitle": "Discover comfort at apartments near Kaiser Permanente Zion Medical Center in La Mesa. Ideal for medical professionals and staff.",
      "page_copy": "The Fletcher provides a perfect home base for medical staff and professionals seeking apartments near Kaiser Permanente Zion Medical Center in La Mesa. Our contemporary one- and two-bedroom apartments boast modern features like stainless steel appliances, custom tile backsplashes, and keyless entry, ensuring your living experience is both stylish and secure.<br>Enjoy communal perks such as a refreshing pool and BBQ area, designed to help you unwind after a busy day at the Medical Center. Located conveniently with easy freeway access, The Fletcher makes commuting simple and stress-free, enhancing your work-life balance in the heart of San Diego County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio area with a pergola and view of the pool and apartment buildings.",
        "public_id": "019d08bf-24f2-72bb-8d91-c3ae58742eb4",
        "storage_key": "property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Kaiser Zion Medical Center | The Fletcher",
      "seo_description": "Find modern apartment living at The Fletcher near Kaiser Permanente Zion Medical Center in La Mesa, ideal for medical professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "generator",
      "page_item_url": "apartments-close-to-sharp-grossmont-hospital-san-diego",
      "search_query": "apartments close to Sharp Grossmont Hospital in San Diego County",
      "category": "Hospital",
      "h1_title": "Apts Near Sharp Grossmont Hospital",
      "h2_subtitle": "Explore apartments close to Sharp Grossmont Hospital in San Diego County. Ideal living for hospital staff and professionals.",
      "page_copy": "The Fletcher offers exceptional living spaces in La Mesa, providing easy access to Sharp Grossmont Hospital in San Diego County. Our one- and two-bedroom apartments are designed with modern comforts, including stainless steel appliances, hard surface floors, and custom tile backsplashes, perfect for busy professionals seeking a blend of style and convenience.<br>Residents enjoy access to a community pool and BBQ area, perfect for relaxation and socializing. Positioned with proximity to major freeways, The Fletcher ensures easy commuting to Sharp Grossmont Hospital, allowing you more time to focus on what matters most. Choose The Fletcher for contemporary apartment living near the heart of healthcare in San Diego County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio area with a pergola and view of the pool and apartment buildings.",
        "public_id": "019d08bf-24f2-72bb-8d91-c3ae58742eb4",
        "storage_key": "property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Sharp Grossmont Hospital | The Fletcher",
      "seo_description": "Discover modern apartments at The Fletcher, close to Sharp Grossmont Hospital in San Diego County, offering convenience for healthcare professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "generator",
      "page_item_url": "apartments-near-mission-trails-regional-park",
      "search_query": "apartments near Mission Trails Regional Park San Diego County",
      "category": "Park",
      "h1_title": "Apts Near Mission Trails Regional Park",
      "h2_subtitle": "Find apartments near Mission Trails Regional Park in San Diego County. Ideal for nature lovers and outdoor enthusiasts.",
      "page_copy": "Embrace the best of nature and modern living at The Fletcher, offering apartments conveniently located near Mission Trails Regional Park in San Diego County. Enjoy spacious one- and two-bedroom floor plans, featuring modern interiors with stainless steel appliances and keyless entry, perfect for those who love outdoor adventures.<br>Take advantage of our community amenities, including a refreshing pool and BBQ area, which complement the vast natural beauty of nearby Mission Trails. With easy access to major freeways, The Fletcher combines the tranquility of nature with the convenience of urban living, making it the perfect home base for exploring all that San Diego County has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio area with a pergola and view of the pool and apartment buildings.",
        "public_id": "019d08bf-24f2-72bb-8d91-c3ae58742eb4",
        "storage_key": "property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Mission Trails Regional Park | The Fletcher",
      "seo_description": "Explore modern living at The Fletcher, offering apartments near Mission Trails Regional Park in San Diego County, perfect for outdoor enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "generator",
      "page_item_url": "rentals-close-to-santee-lakes-recreation-preserve",
      "search_query": "rentals close to Santee Lakes Recreation Preserve CA",
      "category": "Park",
      "h1_title": "Rentals by Santee Lakes Recreation Preserve",
      "h2_subtitle": "Discover rentals close to Santee Lakes Recreation Preserve in CA. Perfect for families and nature enthusiasts in San Diego County.",
      "page_copy": "At The Fletcher, enjoy rentals that offer easy access to the scenic Santee Lakes Recreation Preserve, just a short drive away in San Diego County. Our one- and two-bedroom residences are thoughtfully designed with modern features including stainless steel appliances and stylish hard surface floors, perfect for those who appreciate both comfort and the great outdoors.<br>Beyond your doorstep, enjoy our community features such as a pool and BBQ area, ideal for gatherings and relaxation. Thanks to convenient freeway access, exploring the natural beauty of Santee Lakes and the surrounding area becomes a delightful part of your routine, blending suburban comfort with outdoor charm at The Fletcher.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio area with a pergola and view of the pool and apartment buildings.",
        "public_id": "019d08bf-24f2-72bb-8d91-c3ae58742eb4",
        "storage_key": "property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Santee Lakes Recreation Preserve | The Fletcher",
      "seo_description": "Find your ideal home at The Fletcher, with rentals close to Santee Lakes Recreation Preserve in CA, perfect for nature lovers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "generator",
      "page_item_url": "la-mesa-apartments-by-chollas-lake-park",
      "search_query": "La Mesa apartments by Chollas Lake Park",
      "category": "Park",
      "h1_title": "La Mesa Apts Near Chollas Lake Park",
      "h2_subtitle": "Explore La Mesa apartments by Chollas Lake Park. Ideal for those seeking nature and convenience in San Diego County.",
      "page_copy": "The Fletcher offers charming La Mesa apartments near the picturesque Chollas Lake Park, nestled in the heart of San Diego County. Choose from our stylish one- and two-bedroom floor plans, featuring modern updates such as stainless steel appliances and custom tile backsplashes, making it a perfect fit for those who love style and nature.<br>Residents enjoy community amenities, including a well-maintained pool and BBQ area, ideal for relaxation after a day at Chollas Lake Park. With quick access to major freeways, living in The Fletcher means easy commutes while enjoying proximity to both parkland and urban conveniences, making it a top choice for dynamic living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio area with a pergola and view of the pool and apartment buildings.",
        "public_id": "019d08bf-24f2-72bb-8d91-c3ae58742eb4",
        "storage_key": "property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "La Mesa Apts Near Chollas Lake Park | The Fletcher",
      "seo_description": "Discover modern living at The Fletcher, offering La Mesa apartments near Chollas Lake Park, perfect for nature lovers and city dwellers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "generator",
      "page_item_url": "apartments-near-sdsu-station-la-mesa",
      "search_query": "apartments near SDSU Station La Mesa",
      "category": "Transit",
      "h1_title": "Apts Near SDSU Station La Mesa",
      "h2_subtitle": "Find apartments near SDSU Station in La Mesa, ideal for students and professionals seeking convenient transit access in San Diego County.",
      "page_copy": "Experience the perfect blend of convenience and comfort at The Fletcher, offering apartments near SDSU Station in La Mesa. Our stylish one- and two-bedroom homes boast newly renovated interiors with features like stainless steel appliances and keyless entries, perfect for those who value both style and easy urban access.<br>With the SDSU Station just a short distance away, The Fletcher provides easy commutes for students and professionals. Residents also enjoy access to our community amenities such as a pool and BBQ area, ideal for unwinding after a busy day. Discover how delightful life can be with seamless access to education, work, and play in the vibrant setting of La Mesa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio area with a pergola and view of the pool and apartment buildings.",
        "public_id": "019d08bf-24f2-72bb-8d91-c3ae58742eb4",
        "storage_key": "property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near SDSU Station La Mesa | The Fletcher",
      "seo_description": "Live at The Fletcher, offering apartments near SDSU Station La Mesa, perfect for students and professionals seeking convenience and style.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "generator",
      "page_item_url": "la-mesa-apartments-close-to-lemon-grove-depot",
      "search_query": "La Mesa apartments close to Lemon Grove Depot",
      "category": "Transit",
      "h1_title": "La Mesa Apts by Lemon Grove Depot",
      "h2_subtitle": "Discover La Mesa apartments close to Lemon Grove Depot. Perfect for commuters looking to enjoy San Diego County's charm and convenience.",
      "page_copy": "The Fletcher presents La Mesa apartments conveniently close to Lemon Grove Depot, making it an attractive choice for commuters and those who appreciate easy access to public transport. Our modern one- and two-bedroom units feature contemporary amenities like stainless steel appliances, vibrant hard surface floors, and private backyards.<br>Residents at The Fletcher have access to appealing amenities like a refreshing pool and well-equipped BBQ area, perfect for leisure and social gatherings. Situated in the heart of San Diego County, these apartments provide the perfect blend of suburban peace and metropolitan connectivity, appealing to those looking to balance work and recreation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio area with a pergola and view of the pool and apartment buildings.",
        "public_id": "019d08bf-24f2-72bb-8d91-c3ae58742eb4",
        "storage_key": "property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "La Mesa Apts by Lemon Grove Depot | The Fletcher",
      "seo_description": "Find convenience at The Fletcher, offering La Mesa apartments close to Lemon Grove Depot, perfect for seamless commuting and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "generator",
      "page_item_url": "trolley-station-accessible-apartments-amaya-la-mesa",
      "search_query": "trolley station accessible apartments Amaya La Mesa",
      "category": "Transit",
      "h1_title": "Trolley-Accessible Apts in Amaya La Mesa",
      "h2_subtitle": "Explore trolley station accessible apartments in Amaya, La Mesa. Ideal for those seeking convenience in San Diego's transit-oriented setting.",
      "page_copy": "Discover the convenience of trolley station accessible apartments in Amaya La Mesa at The Fletcher. Our modern one- and two-bedroom homes provide an enriching living experience with features like keyless entry, custom tile backsplashes, and spacious layouts that cater to your lifestyle.<br>Being close to the Amaya trolley station, The Fletcher offers effortless commutes to various parts of San Diego, enhancing your daily life with quick and easy transit options. Our community amenities include a relaxing pool and a barbeque area, fostering a welcoming atmosphere where you can unwind. Experience the ideal balance of efficiency and leisure in the heart of La Mesa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio area with a pergola and view of the pool and apartment buildings.",
        "public_id": "019d08bf-24f2-72bb-8d91-c3ae58742eb4",
        "storage_key": "property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Trolley-Accessible Apts in Amaya La Mesa | The Fletcher",
      "seo_description": "Experience convenience at The Fletcher's trolley station accessible apartments in Amaya, La Mesa. Ideal for fast commutes and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167028",
      "source": "generator",
      "page_item_url": "la-mesa-apartments-near-stadium-san-diego-county",
      "search_query": "La Mesa apartments near Stadium San Diego County",
      "category": "Transit",
      "h1_title": "La Mesa Apts Near Stadium in San Diego",
      "h2_subtitle": "Find La Mesa apartments near the stadium in San Diego County, offering easy access to entertainment and commute convenience.",
      "page_copy": "Discover stylish La Mesa apartments near the stadium in San Diego County at The Fletcher. With newly renovated one- and two-bedroom floor plans, our apartments feature upscale amenities like stainless steel appliances and elegant custom tile backsplashes that cater to contemporary living.<br>Ideal for sports enthusiasts and commuters alike, The Fletcher's proximity to the stadium provides unparalleled access to games, events, and other entertainment options. Residents enjoy community perks, including a sparkling pool and BBQ area, making it a perfect blend of comfort and lifestyle. Experience vibrant living in the heart of La Mesa, where quality and location meet harmoniously.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor patio area with a pergola and view of the pool and apartment buildings.",
        "public_id": "019d08bf-24f2-72bb-8d91-c3ae58742eb4",
        "storage_key": "property/6767906449167028/019d08bf-24f2-72bb-8d91-c3ae58742eb4.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "La Mesa Apts Near Stadium San Diego | The Fletcher",
      "seo_description": "Enjoy seamless access to entertainment at The Fletcher, offering La Mesa apartments near the stadium in San Diego County. Perfect for modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5734"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18224252810"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PXC54NXL"
    },
    {
      "ID": "custom_entrata_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//commoncf.entrata.com/javascript/i18n/i18n.min.js\"></script><script type=\"text/javascript\" src=\"//commoncf.entrata.com/javascript/i18n/entrata-ui.min.js\"></script><script>!function(e){var t=document.createElement(\"script\"),n=function(){ppcb.render({subdomain:\"//apply.thefletcherapts.com\",query:\"is_responsive_snippet=1&snippet_type=contact_button\"})};t.src=\"//commoncf.entrata.com/website_templates/_assets/_common/contact_btn_controller.min.js?ver=1944084\",t.defer=!0,t.async=!0,t.readyState?t.onreadystatechange=function(){(\"loaded\"===t.readyState||\"complete\"===t.readyState)&&n()}:t.onload=n,document.head.appendChild(t)}(window);</script>"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "42169739665"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/40vl5833wle"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "00927850"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkJzWEZjYWRoNG4yNFJHaXBHRVF2Ymc9PSIsInZhbHVlIjoieklhZDI0MmxGMmhKSnFLTE1XY3haUT09IiwibWFjIjoiZjQxMTNkMTIxZmQ2ZmFjYmU0NDY3ZTM0YTg2OTIzNTA1OGY4NDhhOGQ1ZWQ4NTY0YTA4NGViN2JjZmJiMjlkNyJ9"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "5734",
  "custom_repli_id": "18224252810",
  "custom_google_gtm_id": "GTM-PXC54NXL",
  "custom_entrata_chatbot": "<script type=\"text/javascript\" src=\"//commoncf.entrata.com/javascript/i18n/i18n.min.js\"></script><script type=\"text/javascript\" src=\"//commoncf.entrata.com/javascript/i18n/entrata-ui.min.js\"></script><script>!function(e){var t=document.createElement(\"script\"),n=function(){ppcb.render({subdomain:\"//apply.thefletcherapts.com\",query:\"is_responsive_snippet=1&snippet_type=contact_button\"})};t.src=\"//commoncf.entrata.com/website_templates/_assets/_common/contact_btn_controller.min.js?ver=1944084\",t.defer=!0,t.async=!0,t.readyState?t.onreadystatechange=function(){(\"loaded\"===t.readyState||\"complete\"===t.readyState)&&n()}:t.onload=n,document.head.appendChild(t)}(window);</script>",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "42169739665",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/40vl5833wle",
  "custom_website_subscription": "turnkey",
  "custom_broker_license_number": "00927850",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkJzWEZjYWRoNG4yNFJHaXBHRVF2Ymc9PSIsInZhbHVlIjoieklhZDI0MmxGMmhKSnFLTE1XY3haUT09IiwibWFjIjoiZjQxMTNkMTIxZmQ2ZmFjYmU0NDY3ZTM0YTg2OTIzNTA1OGY4NDhhOGQ1ZWQ4NTY0YTA4NGViN2JjZmJiMjlkNyJ9",
  "custom_audioeye_site_id": "533daf4a-0868-414a-8822-52162bf9f61b",
  "custom_audioeye_site_hash": "e6e834a6fc33e1b7267d639c1af2d465"
};

export const generatedAt = '2026-10-20T17:35:55.475Z';
